(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-product-slider"] && !Shopify.designMode) return;
  try {
    
  /* ---------- Left column: image slider ---------- */
  class CollectionImageSlider extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
    }

    connectedCallback() {
      this.track = this.querySelector('[data-slider-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-slider-dot]'));
      this.prevBtn = this.querySelector('[data-slider-prev]');
      this.nextBtn = this.querySelector('[data-slider-next]');
      this.currentIndex = 0;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!this.track) return;
      if (this.slides.length <= 1) return;

      this.autoplayEnabled = this.dataset.autoplay === 'true' && !this.reducedMotion;
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(this.currentIndex - 1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goTo(this.currentIndex + 1));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));

      this.onScroll = this.debounce(this.handleScroll.bind(this), 60);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      this.onResize = this.debounce(() => this.scrollToIndex(this.currentIndex, false), 150);
      window.addEventListener('resize', this.onResize);

      if (this.autoplayEnabled) {
        this.startAutoplay();
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());
      }

      this.update();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      if (this.onResize) window.removeEventListener('resize', this.onResize);
    }

    goTo(index) {
      const count = this.slides.length;
      if (count === 0) return;
      if (index < 0) index = count - 1;
      if (index >= count) index = 0;
      this.currentIndex = index;
      this.scrollToIndex(index, true);
      this.update();
    }

    /* Called by the product selector to sync the slider to a product/variant. */
    scrollToImageId(imageId) {
      if (!this.track) return false;
      const idx = this.slides.findIndex((s) => s.dataset.imageId === String(imageId));
      if (idx === -1) return false;
      this.goTo(idx);
      return true;
    }

    scrollToProductId(productId) {
      if (!this.track) return false;
      const idx = this.slides.findIndex((s) => s.dataset.productId === String(productId));
      if (idx === -1) return false;
      this.goTo(idx);
      return true;
    }

    scrollToIndex(index, smooth) {
      const left = index * this.track.clientWidth;
      this.track.scrollTo({
        left: left,
        behavior: smooth && !this.reducedMotion ? 'smooth' : 'auto',
      });
    }

    handleScroll() {
      const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
      if (index !== this.currentIndex) {
        this.currentIndex = index;
        this.update();
      }
    }

    update() {
      this.dots.forEach((dot, i) => {
        const active = i === this.currentIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    startAutoplay() {
      if (!this.autoplayEnabled) return;
      this.stopAutoplay();
      this.timer = setInterval(() => this.goTo(this.currentIndex + 1), this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }

  if (!customElements.get('collection-image-slider')) {
    customElements.define('collection-image-slider', CollectionImageSlider);
  }

  /* ---------- Right column: product swatches + variants + add to cart ---------- */
  class CollectionProductSelector extends HTMLElement {
    connectedCallback() {
      this.swatches = Array.from(this.querySelectorAll('[data-swatch]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.selectedTitle = this.querySelector('[data-selected-title]');
      this.addButton = this.querySelector('[data-add-to-cart]');

      if (this.swatches.length === 0) return;

      const wrapper = this.closest('.collection-slider');
      this.slider = wrapper ? wrapper.querySelector('collection-image-slider') : null;

      this.swatches.forEach((sw) => {
        sw.addEventListener('click', () => this.selectProduct(sw));
      });
      this.addEventListener('keydown', (e) => this.onKeydown(e));

      this.panels.forEach((panel) => this.initPanel(panel));

      if (this.addButton) {
        this.setupButtonColors();
        this.addButton.addEventListener('click', () => this.addToCart());
      }

      this.guide = this.querySelector('[data-size-guide]');
      if (this.guide) this.initGuide();

      const initial = this.swatches.find((s) => s.getAttribute('aria-checked') === 'true') || this.swatches[0];
      this.selectProduct(initial, true);

      this.preselectFromUrl();
    }

    initPanel(panel) {
      const script = panel.querySelector('[data-variants]');
      try {
        panel.variants = script ? JSON.parse(script.textContent) : [];
      } catch (e) {
        panel.variants = [];
      }

      panel.querySelectorAll('[data-option-value]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const pos = btn.dataset.position;
          panel.querySelectorAll('[data-option-value][data-position="' + pos + '"]').forEach((sibling) => {
            const active = sibling === btn;
            sibling.classList.toggle('is-selected', active);
            sibling.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          this.updateVariant(panel, true);
        });
      });

      this.updateVariant(panel, false);
    }

    getSelectedOptions(panel) {
      const options = [];
      panel.querySelectorAll('[data-option-position]').forEach((group) => {
        const pos = parseInt(group.dataset.optionPosition, 10);
        const selected = group.querySelector('[data-option-value].is-selected');
        if (selected) options[pos - 1] = selected.dataset.value;
      });
      return options;
    }

    updateVariant(panel, fromUser) {
      const variants = panel.variants || [];
      if (variants.length) {
        const selected = this.getSelectedOptions(panel);
        let match = variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
        if (!match) match = variants[0];
        panel.currentVariant = match;

        const priceEl = panel.querySelector('[data-price]');
        if (priceEl) {
          priceEl.innerHTML = match.price + (match.available === false ? ' \u00b7 Sold out' : '');
        }
      }

      if (panel === this.activePanel) this.updateAddToCart();
      if (fromUser) this.syncSlider(panel);
    }

    selectProduct(swatch, silent) {
      const index = swatch.dataset.index;

      this.swatches.forEach((s) => {
        const active = s === swatch;
        s.classList.toggle('is-selected', active);
        s.setAttribute('aria-checked', active ? 'true' : 'false');
        s.tabIndex = active ? 0 : -1;
      });

      this.activePanel = null;
      this.panels.forEach((panel) => {
        const active = panel.dataset.index === index;
        panel.hidden = !active;
        if (active) this.activePanel = panel;
      });

      if (this.selectedTitle) this.selectedTitle.textContent = swatch.dataset.title || '';
      this.updateAddToCart();

      if (!silent) {
        this.syncSlider(this.activePanel);
        swatch.focus();
      }
    }

    /* Scroll the slider to the selected variant's image, or the product's first image. */
    syncSlider(panel) {
      if (!this.slider || !panel) return;
      const variant = panel.currentVariant;
      let done = false;
      if (variant && variant.image_id != null && typeof this.slider.scrollToImageId === 'function') {
        done = this.slider.scrollToImageId(variant.image_id);
      }
      if (!done && typeof this.slider.scrollToProductId === 'function') {
        this.slider.scrollToProductId(panel.dataset.productId);
      }
    }

    updateAddToCart() {
      if (!this.addButton) return;
      const variant = this.activePanel && this.activePanel.currentVariant;
      const soldOut = variant && variant.available === false;
      this.addButton.disabled = !variant || soldOut;
      this.addButton.textContent = soldOut
        ? this.addButton.dataset.soldOutLabel || 'Sold out'
        : this.addButton.dataset.addLabel || 'Add to cart';
    }

    addToCart() {
      const variant = this.activePanel && this.activePanel.currentVariant;
      if (!variant || variant.available === false) return;

      const root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
      this.addButton.classList.add('is-loading');
      this.addButton.disabled = true;

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }),
      })
        .then((response) => response.json())
        .then(() => {
          this.addButton.classList.remove('is-loading');
          document.dispatchEvent(new CustomEvent('cart:added', { bubbles: true, detail: { id: variant.id } }));
          this.flashAdded();
        })
        .catch(() => {
          this.addButton.classList.remove('is-loading');
          this.updateAddToCart();
        });
    }

    flashAdded() {
      this.addButton.disabled = false;
      this.addButton.textContent = this.addButton.dataset.addedLabel || 'Added';
      clearTimeout(this.addedTimer);
      this.addedTimer = setTimeout(() => this.updateAddToCart(), 1800);
    }

    setupButtonColors() {
      const fg = getComputedStyle(this).color;
      const parts = fg.match(/\d+(\.\d+)?/g);
      if (!parts) return;
      const r = Number(parts[0]);
      const g = Number(parts[1]);
      const b = Number(parts[2]);
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      this.style.setProperty('--cs-btn-bg', fg);
      this.style.setProperty('--cs-btn-fg', luminance < 0.55 ? '#ffffff' : '#111111');
    }

    onKeydown(e) {
      const keys = ['ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
      if (keys.indexOf(e.key) === -1) return;

      const current = this.swatches.findIndex((s) => s.getAttribute('aria-checked') === 'true');
      if (current === -1) return;
      e.preventDefault();

      let next = current;
      const last = this.swatches.length - 1;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = current === last ? 0 : current + 1;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = current === 0 ? last : current - 1;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = last;

      this.selectProduct(this.swatches[next]);
    }

    /* ---------- Size guide modal ---------- */
    initGuide() {
      this.guideOpeners = Array.from(this.querySelectorAll('[data-size-guide-open]'));
      this.guideOpeners.forEach((btn) => btn.addEventListener('click', () => this.openGuide(btn)));

      this.guide.querySelectorAll('[data-size-guide-close]').forEach((el) =>
        el.addEventListener('click', () => this.closeGuide(true))
      );
      const ok = this.guide.querySelector('[data-size-guide-ok]');
      if (ok) ok.addEventListener('click', () => this.closeGuide(true));

      this.guide.querySelectorAll('[data-bucket-toggle]').forEach((btn) =>
        btn.addEventListener('click', () => {
          const bucket = btn.closest('[data-bucket]');
          if (!bucket) return;
          const open = bucket.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        })
      );

      this.guide.querySelectorAll('[data-colors-more]').forEach((btn) =>
        btn.addEventListener('click', () => {
          const wrap = btn.closest('[data-colors]');
          if (wrap) wrap.classList.add('is-expanded');
        })
      );

      this.guideColors = Array.from(this.guide.querySelectorAll('[data-guide-color]'));
      this.guideColors.forEach((btn) => btn.addEventListener('click', () => this.setGuidePending(btn)));

      this.onGuideKeydown = (e) => {
        if (e.key === 'Escape') this.closeGuide(true);
      };
    }

    openGuide(trigger) {
      if (!this.guide) return;
      this.guideTrigger = trigger || null;
      this.guidePending = null;

      // Pre-select the colour matching the current variant, if it's shown in the guide.
      this.guideColors.forEach((b) => b.classList.remove('is-selected'));
      const cur = this.activePanel && this.activePanel.currentVariant;
      if (cur) {
        const match = this.guide.querySelector('[data-guide-color][data-variant-id="' + cur.id + '"]');
        if (match) {
          match.classList.add('is-selected');
          this.guidePending = {
            productId: match.dataset.productId,
            variantId: match.dataset.variantId,
          };
          const bucket = match.closest('[data-bucket]');
          if (bucket && !bucket.classList.contains('is-open')) {
            bucket.classList.add('is-open');
            const head = bucket.querySelector('[data-bucket-toggle]');
            if (head) head.setAttribute('aria-expanded', 'true');
          }
        }
      }

      this.guide.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onGuideKeydown);
      const dialog = this.guide.querySelector('.size-guide__dialog');
      if (dialog) dialog.focus();
    }

    closeGuide(commit) {
      if (!this.guide) return;
      if (commit && this.guidePending) {
        this.applyExternalSelection(this.guidePending.productId, this.guidePending.variantId);
      }
      this.guide.hidden = true;
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', this.onGuideKeydown);
      if (this.guideTrigger && typeof this.guideTrigger.focus === 'function') {
        this.guideTrigger.focus();
      }
    }

    setGuidePending(button) {
      this.guideColors.forEach((b) => b.classList.toggle('is-selected', b === button));
      this.guidePending = {
        productId: button.dataset.productId,
        variantId: button.dataset.variantId,
      };
    }

    /* Switch the main picker to a specific product + variant chosen in the guide. */
    /* Honor a ?variant=<id> (or ?fyf_variant=<id>) deep link, e.g. from the
       find-your-fit quiz, by selecting that product + variant on load. */
    preselectFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const vid = params.get('variant') || params.get('fyf_variant');
      if (!vid) return;
      for (let i = 0; i < this.panels.length; i++) {
        const panel = this.panels[i];
        const variants = panel.variants || [];
        if (variants.some((v) => String(v.id) === String(vid))) {
          this.applyExternalSelection(panel.dataset.productId, vid);
          return;
        }
      }
    }

    applyExternalSelection(productId, variantId) {
      const swatch = this.swatches.find((s) => s.dataset.productId === String(productId));
      if (swatch) this.selectProduct(swatch, true);

      const panel = this.activePanel;
      if (!panel) return;

      const variants = panel.variants || [];
      const target = variants.find((v) => String(v.id) === String(variantId));
      if (target && Array.isArray(target.options)) {
        panel.querySelectorAll('[data-option-position]').forEach((group) => {
          const pos = parseInt(group.dataset.optionPosition, 10);
          const want = target.options[pos - 1];
          group.querySelectorAll('[data-option-value]').forEach((btn) => {
            const active = btn.dataset.value === want;
            btn.classList.toggle('is-selected', active);
            btn.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        });
      }

      this.updateVariant(panel, true);
    }
  }

  if (!customElements.get('collection-product-selector')) {
    customElements.define('collection-product-selector', CollectionProductSelector);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-combined-v3-2"]) return;
  try {
    
  /* ---------- Image slider ---------- */
  class CpageImageSlider extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
    }

    connectedCallback() {
      this.track = this.querySelector('[data-slider-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.allSlides = this.slides.slice();
      this.dots = Array.from(this.querySelectorAll('[data-slider-dot]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-slider-thumb]'));
      this.allThumbs = this.thumbs.slice();
      this.thumbStrip = this.querySelector('[data-slider-thumbs]');
      this.thumbPrev = this.querySelector('[data-thumb-prev]');
      this.thumbNext = this.querySelector('[data-thumb-next]');
      this.prevBtn = this.querySelector('[data-slider-prev]');
      this.nextBtn = this.querySelector('[data-slider-next]');
      this.currentIndex = 0;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!this.track || this.slides.length <= 1) return;

      this.applyInitialOrder();

      this.autoplayEnabled = this.dataset.autoplay === 'true' && !this.reducedMotion;
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(this.currentIndex - 1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goTo(this.currentIndex + 1));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const visIdx = this.thumbs.indexOf(thumb);
          if (visIdx !== -1) this.goTo(visIdx);
        });
      });
      if (this.thumbPrev) this.thumbPrev.addEventListener('click', () => this.goTo(this.currentIndex - 1));
      if (this.thumbNext) this.thumbNext.addEventListener('click', () => this.goTo(this.currentIndex + 1));

      this.onScroll = this.debounce(this.handleScroll.bind(this), 60);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      /* Mobile browsers fire resize when the address bar shows/hides, so a height-only resize
         was re-scrolling the track mid page-scroll — the slider appeared to move on its own.
         Only a real width change can invalidate the index * clientWidth math. */
      this.lastWidth = window.innerWidth;
      this.onResize = this.debounce(() => {
        if (window.innerWidth === this.lastWidth) return;
        this.lastWidth = window.innerWidth;
        this.scrollToIndex(this.currentIndex, false);
        this.updateControls();
      }, 150);
      window.addEventListener('resize', this.onResize);

      /* Touch swipe — one slide per swipe, touch devices only */
      this.isTouch = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
      if (this.isTouch) {
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);
        this.track.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.track.addEventListener('touchend', this.onTouchEnd, { passive: true });
      }

      if (this.autoplayEnabled) {
        this.startAutoplay();
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());
      }
      this.update();
      this.updateControls();
      /* Image dimensions can change the overflow after load — recalc once ready */
      this.onLoad = () => this.updateControls();
      window.addEventListener('load', this.onLoad);
    }

    disconnectedCallback() {
      this.stopAutoplay();
      clearTimeout(this._programmaticTimer);
      clearTimeout(this._swipeTimer);
      cancelAnimationFrame(this._settleRaf);
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      if (this.onLoad) window.removeEventListener('load', this.onLoad);
    }

    goTo(index, smooth) {
      const count = this.slides.length;
      if (!count) return;
      if (index < 0) index = count - 1;
      if (index >= count) index = 0;
      this.currentIndex = index;
      this.scrollToIndex(index, smooth !== false);
      this.update();
    }

    scrollToImageId(imageId, smooth) {
      if (!this.track) return false;
      const idx = this.slides.findIndex((s) => s.dataset.imageId === String(imageId));
      if (idx === -1) return false;
      this.goTo(idx, smooth);
      return true;
    }

    scrollToProductId(productId, smooth) {
      if (!this.track) return false;
      const idx = this.slides.findIndex((s) => s.dataset.productId === String(productId));
      if (idx === -1) return false;
      this.goTo(idx, smooth);
      return true;
    }

    /* FIRST-LOAD BROWSE ORDER ONLY. Liquid renders every style's images grouped per product,
       so the unfiltered gallery walks through all of style 1 before style 2 ever appears. We
       hoist ALL of the SECOND style's images to sit right after the FIRST style's first image,
       so the shopper meets a second style immediately:

         lifestyle… → style1 img1 → style2 img1..n → style1 img2..n → style3…

       Only style 2's block moves (plus its thumbs); everything else keeps its rendered spot.
       Nothing here persists: the moment a swatch is picked, filterByProductId rebuilds the
       order from its own filters, and relative order within each style is unaffected by the
       move — so this is purely the "no style chosen yet" view. */
    applyInitialOrder() {
      if (!this.allSlides || this.allSlides.length <= 1) return;

      /* Generic per-product slides only — lifestyle slides lead, and variant slider_images
         slides (data-variant-id) are a per-variant swap, not part of the browse sequence. */
      const isProductSlide = (s) => s.dataset.productId && !s.dataset.variantId;

      const ids = [];
      this.allSlides.forEach((s) => {
        if (isProductSlide(s) && !ids.includes(s.dataset.productId)) ids.push(s.dataset.productId);
      });
      if (ids.length < 2) return;

      const firstIdx = this.allSlides.findIndex((s) => isProductSlide(s) && s.dataset.productId === ids[0]);
      const secondIdxs = [];
      this.allSlides.forEach((s, i) => {
        if (isProductSlide(s) && s.dataset.productId === ids[1]) secondIdxs.push(i);
      });
      if (firstIdx === -1 || !secondIdxs.length) return;
      /* Already sitting where we want them (e.g. style 1 has a single image) — leave the DOM be. */
      if (secondIdxs.every((idx, k) => idx === firstIdx + 1 + k)) return;

      /* Thumbs are rendered in lockstep with the slides (same order, same index), so the
         same index move keeps them aligned — thumbs carry no product id of their own. */
      const move = (arr, parent) => {
        if (!arr || !parent) return;
        const nodes = secondIdxs.map((i) => arr[i]);
        const anchor = arr[firstIdx];
        if (!anchor || nodes.some((n) => !n)) return;
        /* Insert before the same reference node so the block keeps its internal order. */
        const ref = anchor.nextSibling;
        nodes.forEach((node) => parent.insertBefore(node, ref));
        /* Descending removal keeps the not-yet-removed indices valid. */
        secondIdxs.slice().reverse().forEach((i) => arr.splice(i, 1));
        arr.splice(firstIdx + 1, 0, ...nodes);
      };
      move(this.allSlides, this.track);
      move(this.allThumbs, this.thumbStrip);

      /* The live (visible) arrays are the same set in the same order until filtering starts. */
      this.slides = this.allSlides.slice();
      if (this.allThumbs) this.thumbs = this.allThumbs.slice();
    }

    /* Show the selected product's slides plus the always-present lifestyle slides. Only
       called once the shopper has picked a style — until then every slide stays visible in
       its rendered order (lifestyle images first). `lifestyleFirst` leads with the lifestyle
       images instead of trailing them. Slides/thumbs are physically reordered so the
       scroll-index math (index * clientWidth) stays correct.

       When `variantId` names a variant that carries its own custom.slider_images slides, those
       replace the product's generic images entirely; a variant without them falls back to the
       product's own images. Lifestyle slides survive either way. */
    filterByProductId(productId, lifestyleFirst, variantId, targetImageId) {
      if (!this.track || !this.allSlides) return;
      const pid = String(productId);
      const vid = variantId == null ? '' : String(variantId);
      const isLifestyle = (el) => el.dataset.lifestyle === 'true';

      const variantSlides = vid
        ? this.allSlides.filter((s) => s.dataset.variantId === vid)
        : [];
      const productSlides = variantSlides.length
        ? variantSlides
        : this.allSlides.filter((s) => s.dataset.productId === pid && !s.dataset.variantId);
      const lifestyleSlides = this.allSlides.filter(isLifestyle);
      const ordered = lifestyleFirst
        ? lifestyleSlides.concat(productSlides)
        : productSlides.concat(lifestyleSlides);
      const visible = new Set(ordered);

      /* display:none, NOT a collapsed (0-width) flex item. A collapsed slide is still a child
         of a `scroll-snap-type: x mandatory` scroller, so the browser keeps tracking it as a
         snap target: after the style switch it would re-snap to whatever slide the PREVIOUS
         style had snapped to, undoing our jump a frame after we made it. Taking the slide out
         of layout entirely also keeps `index * clientWidth` exact. */
      this.allSlides.forEach((slide) => {
        const show = visible.has(slide);
        slide.style.display = show ? '' : 'none';
        /* Clear the collapse styles earlier versions applied, so a slide that was hidden the
           old way comes back at full width when it's shown again. */
        slide.style.flex = '';
        slide.style.minWidth = '';
        slide.style.overflow = '';
        slide.style.scrollSnapAlign = '';
      });
      ordered.forEach((slide) => this.track.appendChild(slide));
      this.slides = ordered;

      if (this.allThumbs && this.thumbStrip) {
        const orderedThumbs = ordered
          .map((s) => this.allThumbs[this.allSlides.indexOf(s)])
          .filter(Boolean);
        const visThumbs = new Set(orderedThumbs);
        this.allThumbs.forEach((thumb) => { thumb.hidden = !visThumbs.has(thumb); });
        orderedThumbs.forEach((thumb) => this.thumbStrip.appendChild(thumb));
        this.thumbs = orderedThumbs;
        this.eagerLoad(orderedThumbs);
      }

      /* Land on the variant's own image in ONE scroll. Resetting to slide 0 and then jumping
         from the caller meant two scroll writes against a track that had just been rebuilt —
         the second could be clamped to the previous style's (shorter) scrollWidth, which is
         how the gallery ended up parked on the last image instead of the variant's. */
      let target = 0;
      if (targetImageId != null) {
        const idx = ordered.findIndex((s) => s.dataset.imageId === String(targetImageId));
        if (idx !== -1) target = idx;
      }
      this.currentIndex = target;
      this.scrollToIndex(target, false);
      this.update();
      this.updateControls();
      this.settleToIndex(target);
    }

    /* A slide that has never been on screen — display:none, or parked off to the side of the
       track — never intersects the viewport, so its loading="lazy" image is still unfetched.
       Jumping to it programmatically doesn't reliably make the browser re-evaluate that, which
       is why the newly selected style's image stayed blank until the shopper scrolled. Flipping
       the attribute to eager starts the fetch there and then. */
    eagerLoad(elements) {
      elements.forEach((el) => {
        if (!el) return;
        el.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
      });
    }

    /* The slide we're showing plus its neighbours, so a swipe in either direction is already
       decoded. Called from update(), so it keeps up with wherever the shopper lands. */
    preloadAround(index) {
      if (!this.slides) return;
      this.eagerLoad([this.slides[index - 1], this.slides[index], this.slides[index + 1]]);
    }

    /* The track has just been rebuilt, so the jump above can still miss: mandatory scroll-snap
       re-snaps once the new layout is in, and a scrollLeft written before the new widths were
       applied gets clamped. Re-assert the position over the next few frames until the track
       really sits on `index` — and give up the moment the shopper takes over (finger down, or
       a thumbnail click that moved currentIndex elsewhere). */
    settleToIndex(index, tries) {
      if (!this.track) return;
      let left = tries == null ? 5 : tries;
      cancelAnimationFrame(this._settleRaf);
      const step = () => {
        this._settleRaf = requestAnimationFrame(() => {
          if (this.touchStartX != null || this.currentIndex !== index) return;
          /* Keep watching for the whole window rather than stopping at the first frame that
             looks right — the re-snap can land a frame or two after the images lay out. */
          const width = this.track.clientWidth;
          if (width && Math.round(this.track.scrollLeft / width) !== index) {
            this.scrollToIndex(index, false);
          }
          if (--left > 0) step();
        });
      };
      step();
    }

    /* Every programmatic scroll of the track goes through here.
       scrollTo({behavior:'auto'}) is NOT an instant jump: the track sets scroll-behavior:smooth
       in CSS and 'auto' means "use the computed value", so what were meant to be instant resets
       animated instead. On a variant change that left two animations racing (reset to 0, then
       the jump to the variant's image) against mandatory scroll-snap — invisible on a fast
       device, a visible slide-past / jitter / wrong-slide landing on a slow one. */
    scrollTrackTo(left, smooth) {
      if (!this.track) return;
      const animate = smooth && !this.reducedMotion;
      /* Ignore the scroll events our own scrolling produces until it has settled (see
         handleScroll), then reconcile in case snapping landed somewhere else. */
      this._programmatic = true;
      clearTimeout(this._programmaticTimer);
      this._programmaticTimer = setTimeout(() => {
        this._programmatic = false;
        this.handleScroll();
      }, animate ? 700 : 150);

      if (animate) {
        this.track.scrollTo({ left: left, behavior: 'smooth' });
        return;
      }
      const previous = this.track.style.scrollBehavior;
      this.track.style.scrollBehavior = 'auto';
      this.track.scrollLeft = left;
      this.track.style.scrollBehavior = previous;
    }

    scrollToIndex(index, smooth) {
      if (!this.track) return;
      /* No width = not laid out yet (hidden column, mid re-render). index * 0 would silently
         send the track back to the first slide; leave it and let load/resize re-run this. */
      const width = this.track.clientWidth;
      if (!width) return;
      this.scrollTrackTo(index * width, smooth);
    }

    handleScroll() {
      if (this._programmatic) return;
      /* clientWidth is 0 while the track is unlaid-out — the division would make currentIndex
         NaN, which then breaks every later goTo/update until the page is reloaded. */
      const width = this.track.clientWidth;
      if (!width) return;
      const index = Math.round(this.track.scrollLeft / width);
      if (index !== this.currentIndex && index >= 0 && index < this.slides.length) {
        this.currentIndex = index;
        this.update();
      }
    }

    /* Arrows are only needed when the visible slides actually overflow the track */
    needsArrows() {
      if (!this.track || this.slides.length <= 1) return false;
      return this.track.scrollWidth - this.track.clientWidth > 1;
    }

    updateControls() {
      const need = this.needsArrows();
      if (this.prevBtn) this.prevBtn.hidden = !need;
      if (this.nextBtn) this.nextBtn.hidden = !need;

      const strip = this.thumbStrip;
      const thumbNeed = this.thumbs.length > 1 && strip && strip.scrollWidth - strip.clientWidth > 1;
      if (this.thumbPrev) this.thumbPrev.hidden = !thumbNeed;
      if (this.thumbNext) this.thumbNext.hidden = !thumbNeed;
    }

    onTouchStart(e) {
      const t = e.changedTouches[0];
      this.touchStartX = t.clientX;
      this.touchStartY = t.clientY;
      this.swipeStartIndex = this.currentIndex;
      /* The finger wins over anything we were animating */
      clearTimeout(this._programmaticTimer);
      clearTimeout(this._swipeTimer);
      this._programmatic = false;
      this.stopAutoplay();
    }

    onTouchEnd(e) {
      if (this.touchStartX == null) return;
      const t = e.changedTouches[0];
      const dx = t.clientX - this.touchStartX;
      const dy = t.clientY - this.touchStartY;
      this.touchStartX = null;
      const start = this.swipeStartIndex;
      /* Horizontal swipe past the threshold → advance exactly one slide */
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        /* The track is a native snap scroller, so the finger has usually already moved it by
           the time touchend fires — scrolling right here fought the momentum still running
           (stutter / bounce-back on devices where the fling is slower to settle). Let it land
           first, then only correct it if it didn't end up one slide along: a short drag the
           snap ignored, or a hard fling that crossed several slides (iOS Safari doesn't
           implement scroll-snap-stop, so it can travel well past one). */
        const wanted = start + (dx < 0 ? 1 : -1);
        clearTimeout(this._swipeTimer);
        this._swipeTimer = setTimeout(() => {
          const width = this.track.clientWidth;
          if (!width) return;
          if (Math.round(this.track.scrollLeft / width) !== wanted) this.goTo(wanted);
        }, 160);
      }
      if (this.autoplayEnabled) this.startAutoplay();
    }

    update() {
      this.preloadAround(this.currentIndex);
      this.dots.forEach((dot, i) => {
        const active = i === this.currentIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      this.thumbs.forEach((thumb, i) => {
        const active = i === this.currentIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      const activeThumb = this.thumbs[this.currentIndex];
      if (activeThumb && this.thumbStrip) {
        /* Reveal the active thumb by scrolling the strip horizontally only — never
           scrollIntoView, which also scrolls the page (and on load jumped the whole
           page down to the strip when it sat below the fold). */
        const strip = this.thumbStrip;
        const stripRect = strip.getBoundingClientRect();
        const thumbRect = activeThumb.getBoundingClientRect();
        const delta = thumbRect.left - stripRect.left - (stripRect.width - thumbRect.width) / 2;
        if (this.reducedMotion) {
          /* 'auto' would animate anyway — the strip sets scroll-behavior: smooth in CSS */
          const previous = strip.style.scrollBehavior;
          strip.style.scrollBehavior = 'auto';
          strip.scrollLeft += delta;
          strip.style.scrollBehavior = previous;
        } else {
          strip.scrollBy({ left: delta, behavior: 'smooth' });
        }
      }
    }

    startAutoplay() {
      if (!this.autoplayEnabled) return;
      this.stopAutoplay();
      this.timer = setInterval(() => this.goTo(this.currentIndex + 1), this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }

  if (!customElements.get('cpage-image-slider')) {
    customElements.define('cpage-image-slider', CpageImageSlider);
  }

  /* ---------- Product selector ---------- */
  class CpageProductSelector extends HTMLElement {
    connectedCallback() {
      this.swatches = Array.from(this.querySelectorAll('[data-swatch]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.selectedTitle = this.querySelector('[data-selected-title]');
      this.addButton = this.querySelector('[data-add-to-cart]');
      /* Combined-listing / product page: add-to-cart is a real Shopify product form so
         the theme's product-form-component (AJAX add + cart drawer) and cart/bundle apps
         like Kaching can hook it. We keep the form's hidden variant id in sync with the
         selected style; the form submit — not a custom fetch — performs the add. */
      this.cartForm = this.querySelector('[data-cps-form], form[action*="/cart/add"]');
      this.variantIdInput = this.querySelector('[data-cps-variant-id]');
      /* AJAX cart mode (section setting) — we perform the add ourselves so cart-drawer apps
         like UpCart open their drawer instead of the page navigating to /cart. */
      this.ajaxCart = !!(this.cartForm && this.cartForm.dataset.cpsCart === 'ajax');
      if (this.ajaxCart) {
        this.cartForm.addEventListener('submit', (e) => { e.preventDefault(); this.ajaxAdd(); });
      }

      if (this.swatches.length === 0) return;

      const wrapper = this.closest('.cpslider');
      this.slider = wrapper ? wrapper.querySelector('cpage-image-slider') : null;

      /* Tracks whether the shopper has actively picked a style yet. Drives lifestyle-image
         ordering in the slider: false → lifestyle images lead; true → they trail. */
      this.userInteracted = false;
      this.swatches.forEach((sw) => sw.addEventListener('click', () => { this.userInteracted = true; this.selectProduct(sw); }));
      this.addEventListener('keydown', (e) => this.onKeydown(e));
      this.panels.forEach((panel) => this.initPanel(panel));

      if (this.addButton) {
        this.setupButtonColors();
        /* The product form's native submit (theme's product-form-component, also hooked by
           Kaching) performs the add — we don't fetch. But we still reflect adding → added on
           the button for UX. The click fires for both paths; we never call preventDefault or
           set the disabled attribute (that could block the submit), only visual state. */
        /* capture phase so our visual state fires even if Kaching stops bubble propagation */
        this.addButton.addEventListener('click', () => this.onAddClick(), true);
      }

      /* The size-guide overlay and the fitting-guide drawer are rendered outside this element
         (and outside the sticky info column) so they can paint above the header — resolve them
         from the .cpslider root, not from `this`. Their triggers still live in the blocks. */
      this.cpsRoot = this.closest('.cpslider') || this.closest('.shopify-section') || document;
      this.guide = this.cpsRoot.querySelector('[data-size-guide]');
      if (this.guide) this.initGuide();

      this.initAccordions();
      this.initFitGuideDrawers();

      const initial = this.swatches.find((s) => s.getAttribute('aria-checked') === 'true') || this.swatches[0];
      this.selectProduct(initial, true);
      this.preselectFromUrl();
      this.initExternalVariantSync();
    }

    initPanel(panel) {
      const script = panel.querySelector('[data-variants]');
      try {
        panel.variants = script ? JSON.parse(script.textContent) : [];
      } catch {
        panel.variants = [];
      }

      panel.querySelectorAll('[data-option-value]').forEach((btn) => {
        btn.addEventListener('click', () => {
          this.userInteracted = true;
          const pos = btn.dataset.position;
          panel.querySelectorAll('[data-option-value][data-position="' + pos + '"]').forEach((sibling) => {
            const active = sibling === btn;
            sibling.classList.toggle('is-selected', active);
            sibling.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          this.updateSelectedValueDisplay(panel, pos);
          this.updateVariant(panel, true);
        });
      });

      this.updateVariant(panel, false);
    }

    updateSelectedValueDisplay(panel, position) {
      const selected = panel.querySelector('[data-option-value][data-position="' + position + '"].is-selected');
      if (selected) {
        const display = panel.querySelector('[data-selected-value-' + position + ']');
        if (display) {
          display.textContent = selected.dataset.value;
        }
      }
    }

    getSelectedOptions(panel) {
      const options = [];
      panel.querySelectorAll('[data-option-position]').forEach((group) => {
        const pos = parseInt(group.dataset.optionPosition, 10);
        const selected = group.querySelector('[data-option-value].is-selected');
        if (selected) options[pos - 1] = selected.dataset.value;
      });
      return options;
    }

    /* data-price lives in the buttons block (outside panels); only update when this is the active panel */
    updateVariant(panel, fromUser) {
      const variants = panel.variants || [];
      if (variants.length) {
        const selected = this.getSelectedOptions(panel);
        let match = variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
        if (!match) match = variants[0];
        panel.currentVariant = match;
      }

      this.updateSwatchImage(panel);

      if (panel === this.activePanel) {
        const v = panel.currentVariant;
        /* Fitting guide follows the colour variant, so refresh it here rather than in
           selectProduct — currentVariant is only settled once we've matched the options. */
        this.updateFitGuideImages(panel.dataset.index, v && v.id);
        const priceEl = this.querySelector('[data-price]');
        if (priceEl) {
          priceEl.textContent = v ? v.price + (v.available === false ? ' · Sold out' : '') : '';
        }
        /* Compare-at price: only shown when the variant is actually discounted */
        const compareEl = this.querySelector('[data-compare-price]');
        if (compareEl) {
          const compare = v && v.compare_at_price;
          compareEl.textContent = compare || '';
          compareEl.hidden = !compare;
        }
        this.updateAddToCart();
      }

      if (fromUser) this.syncSlider(panel);
    }

    /* Point a style/brand swatch at the image of the variant currently selected inside its
       panel, so picking a colour re-skins the swatch. Variants without their own image fall
       back to the product's featured image captured in data-default-src. */
    updateSwatchImage(panel) {
      const swatch = this.swatches.find((s) => s.dataset.index === panel.dataset.index);
      const img = swatch && swatch.querySelector('[data-swatch-img]');
      if (!img) return;
      const variant = panel.currentVariant;
      const next = (variant && variant.image) || img.dataset.defaultSrc;
      /* compare the attribute, not img.src — the latter is resolved to an absolute URL */
      if (next && img.getAttribute('src') !== next) img.setAttribute('src', next);
    }
    
    selectProduct(swatch, silent) {
      const index = swatch.dataset.index;

      this.swatches.forEach((s) => {
        const active = s === swatch;
        s.classList.toggle('is-selected', active);
        s.setAttribute('aria-checked', active ? 'true' : 'false');
        s.tabIndex = active ? 0 : -1;
      });

      this.activePanel = null;
      this.panels.forEach((panel) => {
        const active = panel.dataset.index === index;
        panel.hidden = !active;
        if (active) this.activePanel = panel;
      });

      /* Scoped to the .cpslider root, not to `this`: the fitting-guide drawer carries its own
         [data-selected-title] and is rendered outside this element (see connectedCallback), so
         a `this`-scoped query would leave its heading stuck on the first product's title. */
      (this.cpsRoot || this).querySelectorAll('[data-selected-title]').forEach((el) => {
        el.textContent = swatch.dataset.title || '';
      });

      /* "Available Size" card — concise band for the selected style; hidden when unknown */
      const availEl = this.querySelector('[data-avail-size]');
      const bandEl = this.querySelector('[data-size-band-text]');
      const band = swatch.dataset.sizeBand || '';
      if (bandEl) bandEl.textContent = band;
      if (availEl) availEl.hidden = !band;

      /* The size-fit warning note reflects whether the NOW-selected swatch fits the chosen
         size, so refresh it on every selection change (the size selector owns the note text). */
      const sizeFit = (this.cpsRoot || this).querySelector('size-fit-selector');
      if (sizeFit && typeof sizeFit.updateSelectedFitNote === 'function') sizeFit.updateSelectedFitNote();

      /* updateVariant handles price, add-to-cart and the fitting guide for the active panel */
      if (this.activePanel) this.updateVariant(this.activePanel, false);
      else {
        this.updateFitGuideImages(index, null);
        this.updateAddToCart();
      }

      /* Filter the slider to the selected product, but only once the shopper has
         interacted — the initial (silent) selection leaves every image on show. */
      this.syncSlider(this.activePanel);
      /* Move focus for keyboard/a11y, but never scroll the page to the swatch — the
         default focus() scroll-into-view was jumping the page on select. */
      if (!silent) {
        swatch.focus({ preventScroll: true });
        /* Blur after a short delay so the tooltip (shown on :focus-visible) disappears */
        requestAnimationFrame(() => swatch.blur());
      }
    }

    syncSlider(panel) {
      if (!this.slider || !panel) return;
      /* On page load the slider shows everything — every style's images, led by the
         lifestyle images — so the shopper sees the full range before choosing. Filtering to a
         single style begins at the first swatch/option/keyboard pick, or immediately when the
         URL already names a variant (?variant= / ?fyf_variant=), which is an explicit pick. */
      if (!this.userInteracted) return;
      /* The slider element may not have upgraded/connected yet (e.g. image column
         positioned right renders after this selector). Retry once it's ready. */
      if (!this.slider.track) {
        if (!this._syncRetried) {
          this._syncRetried = true;
          requestAnimationFrame(() => this.syncSlider(panel));
        }
        return;
      }
      this._syncRetried = false;
      /* Once filtering, the lifestyle images trail the selected style's own images. The
         variant's image id goes IN with the filter so the rebuilt track is scrolled to it
         exactly once. Filtering first and calling scrollToImageId afterwards meant two scroll
         writes on a track whose new widths were a frame old — the gallery could land on the
         first or the last slide instead of the variant's image, and only correct itself once
         the shopper scrolled. */
      const variant = panel.currentVariant;
      this.slider.filterByProductId(
        panel.dataset.productId,
        false,
        variant && variant.id,
        variant && variant.image_id != null ? variant.image_id : null
      );
    }

    updateAddToCart() {
      if (!this.addButton) return;
      const variant = this.activePanel && this.activePanel.currentVariant;
      const soldOut = variant && variant.available === false;
      this.addButton.disabled = !variant || soldOut;

      /* Keep the product form's hidden variant id in sync with the selected style so the
         native form submit (and any cart/bundle app hooking it) adds the right variant.
         Disabled inputs aren't submitted, so we also gate it on availability. */
      if (this.variantIdInput && !this._applyingExternal) {
        /* While applying a selection that CAME FROM Kaching (_applyingExternal), the shared id
           is already what Kaching set — writing it back (incl. the transient default-variant id
           mid-apply) makes Kaching re-map all its bundle slots and clobber other picks. So we
           only sync the id for our own selections here.
           Flag this as our own write so the watcher doesn't mistake it for a customer change and
           loop. _lastVariantId tracks the value we last put there, compared in onExternalVariantId. */
        this._settingVariantId = true;
        if (variant && !soldOut) {
          this.variantIdInput.value = variant.id;
          this.variantIdInput.disabled = false;
          this._lastVariantId = String(variant.id);
        } else {
          this.variantIdInput.value = '';
          this.variantIdInput.disabled = true;
          this._lastVariantId = '';
        }
        this._settingVariantId = false;
      }

      if (soldOut) {
        this.addButton.textContent = this.addButton.dataset.soldOutLabel || 'Sold out';
        return;
      }
      let label = this.addButton.dataset.addLabel || 'Add to cart';
      /* optionally show the live variant price in the button, e.g. "Add to cart · $70.00" */
      if (this.addButton.dataset.showPrice === 'true' && variant && variant.price) {
        label += (this.addButton.dataset.priceSeparator || ' · ') + variant.price;
      }
      this.addButton.textContent = label;
    }

    /* ---- Add-to-cart visual state (the form/Kaching do the actual add) ---- */
    onAddClick() {
      const variant = this.activePanel && this.activePanel.currentVariant;
      /* sold out / no variant → button is disabled and won't submit; nothing to show */
      if (!variant || variant.available === false) return;
      this.startAdding();
    }

    /* AJAX add (portable cart mode): post to /cart/add.js, then notify cart-drawer apps/themes.
       UpCart also intercepts this fetch directly, which is what opens its drawer. */
    ajaxAdd() {
      const variant = this.activePanel && this.activePanel.currentVariant;
      if (!variant || variant.available === false) return;
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      this.startAdding();
      clearTimeout(this._addingTimer); // the real fetch drives completion, not the fallback timer
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }),
      })
        .then((r) => r.json())
        .then((data) => {
          if (data && data.status) throw new Error(data.description || 'add failed');
          this.markAdded();
          this.notifyCart();
        })
        .catch(() => {
          this._adding = false;
          if (this.addButton) this.addButton.classList.remove('is-loading');
          this.updateAddToCart();
        });
    }

    notifyCart() {
      /* Broadcast widely so whatever cart drawer is present refreshes/opens (theme- and
         app-agnostic). UpCart hooks the fetch above; these cover native theme drawers. */
      ['cart:refresh', 'cart:updated', 'cart:change', 'ajaxProduct:added', 'product:added'].forEach((name) =>
        document.dispatchEvent(new CustomEvent(name, { bubbles: true }))
      );
      try {
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'cpslider' });
        }
      } catch (e) {}
    }

    startAdding() {
      if (!this.addButton || this._adding) return;
      this._adding = true;
      /* capture the live text colour so the spinner is visible once we hide the label */
      this.addButton.style.setProperty('--cps-spin', getComputedStyle(this.addButton).color);
      this.addButton.classList.remove('is-added');
      this.addButton.classList.add('is-loading');
      clearTimeout(this._addedTimer);
      clearTimeout(this._addingTimer);
      /* We don't get a reliable completion signal across the theme form + Kaching + UpCart,
         so show the spinner briefly, then confirm with "Added". */
      this._addingTimer = setTimeout(() => this.markAdded(), 1000);
    }

    markAdded() {
      if (!this.addButton || !this._adding) return;
      this._adding = false;
      clearTimeout(this._addingTimer);
      this.addButton.classList.remove('is-loading');
      this.addButton.classList.add('is-added');
      this.addButton.textContent = this.addButton.dataset.addedLabel || 'Added';
      clearTimeout(this._addedTimer);
      this._addedTimer = setTimeout(() => {
        this.addButton.classList.remove('is-added');
        this.updateAddToCart();
      }, 1800);
    }

    addToCart() {
      const variant = this.activePanel && this.activePanel.currentVariant;
      if (!variant || variant.available === false) return;

      const root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
      this.addButton.classList.add('is-loading');
      this.addButton.disabled = true;

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }),
      })
        .then((r) => r.json())
        .then(() => {
          this.addButton.classList.remove('is-loading');
          document.dispatchEvent(new CustomEvent('cart:added', { bubbles: true, detail: { id: variant.id } }));
          this.flashAdded();
          this.openCartDrawer(root);
        })
        .catch(() => {
          this.addButton.classList.remove('is-loading');
          this.updateAddToCart();
        });
    }

    openCartDrawer(root) {
      const SECTION = 'cart-drawer-section';
      fetch((root || '/') + '?sections=' + SECTION)
        .then((r) => r.json())
        .then((data) => {
          const html = data[SECTION];
          if (html) {
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const fresh = parsed.getElementById('shopify-section-' + SECTION);
            const current = document.getElementById('shopify-section-' + SECTION);
            if (fresh && current) current.innerHTML = fresh.innerHTML;
          }
        })
        .catch(() => {})
        .finally(() => {
          const drawer = document.querySelector('theme-drawer#cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          } else if (window.Shopify?.actions?.openCart) {
            window.Shopify.actions.openCart();
          } else {
            window.location.href = root + 'cart';
          }
        });
    }

    flashAdded() {
      this.addButton.disabled = false;
      this.addButton.textContent = this.addButton.dataset.addedLabel || 'Added';
      clearTimeout(this.addedTimer);
      this.addedTimer = setTimeout(() => this.updateAddToCart(), 1800);
    }

    setupButtonColors() {
      const fg = getComputedStyle(this).color;
      const parts = fg.match(/\d+(\.\d+)?/g);
      if (!parts) return;
      const luminance = (0.299 * Number(parts[0]) + 0.587 * Number(parts[1]) + 0.114 * Number(parts[2])) / 255;
      this.style.setProperty('--cps-btn-bg', fg);
      this.style.setProperty('--cps-btn-fg', luminance < 0.55 ? '#ffffff' : '#111111');
    }

    onKeydown(e) {
      const keys = ['ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
      if (!keys.includes(e.key)) return;
      const current = this.swatches.findIndex((s) => s.getAttribute('aria-checked') === 'true');
      if (current === -1) return;
      e.preventDefault();
      const last = this.swatches.length - 1;
      let next = current;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = current === last ? 0 : current + 1;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = current === 0 ? last : current - 1;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = last;
      this.userInteracted = true;
      this.selectProduct(this.swatches[next]);
    }

    /* ---------- Size guide ---------- */
    initGuide() {
      this.guideOpeners = Array.from(this.querySelectorAll('[data-size-guide-open]'));
      this.guideOpeners.forEach((btn) => btn.addEventListener('click', () => this.openGuide(btn)));

      this.guide
        .querySelectorAll('[data-size-guide-close]')
        .forEach((el) => el.addEventListener('click', () => this.closeGuide(true)));
      const ok = this.guide.querySelector('[data-size-guide-ok]');
      if (ok) ok.addEventListener('click', () => this.closeGuide(true));

      this.guide.querySelectorAll('[data-bucket-toggle]').forEach((btn) =>
        btn.addEventListener('click', () => {
          const bucket = btn.closest('[data-bucket]');
          if (!bucket) return;
          const willOpen = !bucket.classList.contains('is-open');
          this.guide.querySelectorAll('[data-bucket]').forEach((b) => {
            b.classList.remove('is-open');
            const h = b.querySelector('[data-bucket-toggle]');
            if (h) h.setAttribute('aria-expanded', 'false');
          });
          if (willOpen) {
            bucket.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          }
        })
      );

      this.guide.querySelectorAll('[data-colors-more]').forEach((btn) =>
        btn.addEventListener('click', () => {
          const wrap = btn.closest('[data-colors]');
          if (wrap) wrap.classList.add('is-expanded');
        })
      );

      this.guideColors = Array.from(this.guide.querySelectorAll('[data-guide-color]'));
      this.guideColors.forEach((btn) => btn.addEventListener('click', () => this.setGuidePending(btn)));

      this.guide.querySelectorAll('[data-guide-card]').forEach((card) => {
        card.addEventListener('click', (e) => {
          if (e.target.closest('[data-guide-color]')) return;
          const firstColor = card.querySelector('[data-guide-color]');
          if (firstColor) this.setGuidePending(firstColor);
        });
      });

      this.onGuideKeydown = (e) => {
        if (e.key === 'Escape') this.closeGuide(true);
      };
    }

    openGuide(trigger) {
      if (!this.guide) return;
      this.guideTrigger = trigger || null;
      this.guidePending = null;

      this.guideColors.forEach((b) => b.classList.remove('is-selected'));
      this.guide.querySelectorAll('[data-guide-thumb]').forEach((img) => {
        if (img.dataset.defaultSrc) img.src = img.dataset.defaultSrc;
      });
      this.guide.querySelectorAll('[data-bucket]').forEach((b) => {
        b.classList.remove('is-open');
        const h = b.querySelector('[data-bucket-toggle]');
        if (h) h.setAttribute('aria-expanded', 'false');
      });
      this.updateNiceText(null);

      clearTimeout(this._guideHideTimer);
      this.guide.hidden = false;
      /* two frames so the panel paints off-screen before the drawer slides in */
      requestAnimationFrame(() => requestAnimationFrame(() => this.guide.classList.add('is-open')));
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onGuideKeydown);
      const dialog = this.guide.querySelector('.cpsg__dialog');
      if (dialog) dialog.focus();
    }

    closeGuide(commit) {
      if (!this.guide) return;
      if (commit && this.guidePending) {
        /* Confirming a size-guide pick IS an explicit choice, so it starts the slider's
           per-style filtering exactly like clicking a swatch does. Without this the flag was
           still false on a fresh page load (nothing else had been touched), so syncSlider
           returned early and neither the slides nor the thumbnails were filtered.
           Set BEFORE applying — selectProduct calls syncSlider, which reads the flag. */
        this.userInteracted = true;
        this.applyExternalSelection(this.guidePending.productId, this.guidePending.variantId);
      }
      this.guide.classList.remove('is-open');
      /* drawer variant slides out — wait for the transition before hiding; modal hides at once */
      const isDrawer = this.guide.classList.contains('cpsg--drawer');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (isDrawer && !reduced) {
        clearTimeout(this._guideHideTimer);
        this._guideHideTimer = setTimeout(() => { this.guide.hidden = true; }, 320);
      } else {
        this.guide.hidden = true;
      }
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', this.onGuideKeydown);
      if (this.guideTrigger && typeof this.guideTrigger.focus === 'function') this.guideTrigger.focus();
    }

    setGuidePending(button) {
      this.guideColors.forEach((b) => b.classList.toggle('is-selected', b === button));
      this.guidePending = { productId: button.dataset.productId, variantId: button.dataset.variantId };
      this.updateNiceText(button);
      this.updateGuideCardImage(button);
    }

    /* Show the selected colour's variant image; fall back to the card's main image */
    updateGuideCardImage(button) {
      const card = button.closest('[data-guide-card]');
      if (!card) return;
      const img = card.querySelector('[data-guide-thumb]');
      if (!img) return;
      const variantImage = button.dataset.variantImage;
      img.src = variantImage || img.dataset.defaultSrc || img.src;
    }

    updateNiceText(button) {
      const niceText = this.guide && this.guide.querySelector('[data-guide-nice-text]');
      const nameEl = this.guide && this.guide.querySelector('[data-guide-selected-name]');
      if (!niceText || !nameEl) return;
      const title = button && button.dataset.productTitle;
      if (title) {
        nameEl.textContent = title;
        niceText.hidden = false;
      } else {
        niceText.hidden = true;
      }
    }

    initAccordions() {
      this.querySelectorAll('[data-accordion-head]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const item = btn.closest('[data-accordion]');
          if (!item) return;
          const isOpen = item.classList.contains('is-open');
          item.classList.toggle('is-open', !isOpen);
          btn.setAttribute('aria-expanded', String(!isOpen));
        });
      });
    }

    /* Resolve fitting-guide image URLs for a style index + colour variant:
       variant metafield → product metafield → the block's default image. */
    resolveFitUrls(container, index, variantId) {
      if (container._fitMap === undefined) {
        const script = container.querySelector('[data-fitguide-map]');
        try {
          container._fitMap = script ? JSON.parse(script.textContent) : {};
        } catch {
          container._fitMap = {};
        }
      }
      const entry = (container._fitMap || {})[index] || {};
      const byVariant = entry.variants || {};
      let urls = (variantId && byVariant[String(variantId)]) || entry.product || [];
      if (!urls.length && container.dataset.defaultImage) urls = [container.dataset.defaultImage];
      return urls;
    }

    /* Called on style/colour change: remember the resolved images per container, and if the
       shared drawer is currently showing that container, swap its images in place. */
    updateFitGuideImages(index, variantId) {
      (this.cpsRoot || this).querySelectorAll('[data-fitguide]').forEach((container) => {
        container._fitIndex = index;
        container._fitUrls = this.resolveFitUrls(container, index, variantId);
        if (window.SaintFG && window.SaintFG.isOpen() && window.SaintFG.currentId === container.id) {
          this.openSharedFit(container, this.fitOpenTrigger);
        }
      });
    }

    /* Open (or refresh) the shared fitting-guide drawer for a container. Title reads
       "<prefix> <selected product>"; body + images come from the container's data. */
    openSharedFit(container, trigger) {
      if (!window.SaintFG || !container) return;
      const titleEl =
        (trigger && trigger.querySelector('[data-selected-title]')) ||
        (this.cpsRoot || this).querySelector('[data-selected-title]');
      const bodyTpl = container.querySelector('[data-fitguide-body]');
      const urls =
        container._fitUrls || this.resolveFitUrls(container, container._fitIndex || '0', null);
      window.SaintFG.open({
        id: container.id,
        title: container.dataset.fitguidePrefix || '',
        productName: (titleEl && titleEl.textContent) || '',
        bodyHtml: bodyTpl ? bodyTpl.innerHTML : '',
        images: urls
      });
    }

    /* ---------- Fitting-guide drawer → shared window.SaintFG ---------- */
    // The visible drawer, zoom/pan, close and Escape all live in the shared snippet.
    // Each trigger resolves its data container ([data-fitguide]) and opens the drawer.
    initFitGuideDrawers() {
      const triggers = Array.from(this.querySelectorAll('[data-fitguide-open]'));
      if (!triggers.length) return;
      triggers.forEach((btn) => {
        /* The trigger card lives in the swatches block, so resolve its data container by the
           target id it points at; fall back to an ancestor [data-fitguide] container. */
        let container = null;
        if (btn.dataset.fitguideTarget) container = document.getElementById(btn.dataset.fitguideTarget);
        if (!container) container = btn.closest('[data-fitguide]');
        if (!container) return;
        btn.addEventListener('click', () => {
          this.fitOpenTrigger = btn;
          this.openSharedFit(container, btn);
        });
      });
    }

    preselectFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const vid = params.get('variant') || params.get('fyf_variant');
      if (!vid) return;
      for (const panel of this.panels) {
        if ((panel.variants || []).some((v) => String(v.id) === String(vid))) {
          /* A deep link (?variant=, or ?fyf_variant= from the Find Your Fit quiz) is an explicit
             pick, not a browse — so the gallery filters to that style on first load rather than
             waiting for a click. Set before applying: syncSlider reads this flag. */
          this.userInteracted = true;
          this.applyExternalSelection(panel.dataset.productId, vid);
          return;
        }
      }
    }

    applyExternalSelection(productId, variantId) {
      const swatch = this.swatches.find((s) => s.dataset.productId === String(productId));
      if (swatch) this.selectProduct(swatch, true);

      const panel = this.activePanel;
      if (!panel) return;

      const target = (panel.variants || []).find((v) => String(v.id) === String(variantId));
      if (target && Array.isArray(target.options)) {
        panel.querySelectorAll('[data-option-position]').forEach((group) => {
          const pos = parseInt(group.dataset.optionPosition, 10);
          const want = target.options[pos - 1];
          group.querySelectorAll('[data-option-value]').forEach((btn) => {
            const active = btn.dataset.value === want;
            btn.classList.toggle('is-selected', active);
            btn.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          this.updateSelectedValueDisplay(panel, pos);
        });
      }

      this.updateVariant(panel, true);
    }

    /* ---- External selection sync (Kaching bundles / any app-driven variant change) ----
       Our swatch normally drives the shared form's hidden variant id (updateAddToCart). When
       Kaching lets the customer switch variant/style in its own widget, it changes that same
       id. We watch it for changes we didn't make and move the swatch (+ reflect the exact
       variant's options) to match, reusing applyExternalSelection.

       Kaching's write mechanism isn't known, so we cover them all: bubbling change/input
       events, common variant pub-sub events, attribute mutations, and a cheap safety-net poll
       for property-only writes (input.value = … fires no event and doesn't touch the
       attribute). Every path funnels through onExternalVariantId, which no-ops unless the id
       genuinely changed to one of our variants. */
    initExternalVariantSync() {
      if (!this.variantIdInput) return;
      if (this._lastVariantId == null) this._lastVariantId = String(this.variantIdInput.value || '');

      this._extVariantCheck = () => this.onExternalVariantId(this.variantIdInput.value);

      ['change', 'input'].forEach((evt) => this.variantIdInput.addEventListener(evt, this._extVariantCheck));
      this._extVariantEvents = ['variant:change', 'variantChange', 'product:variant-change', 'on:variant:change'];
      this._extVariantEvents.forEach((evt) => document.addEventListener(evt, this._extVariantCheck));

      try {
        this._variantObserver = new MutationObserver(this._extVariantCheck);
        this._variantObserver.observe(this.variantIdInput, { attributes: true, attributeFilter: ['value'] });
      } catch (e) {}

      this._variantPoll = setInterval(this._extVariantCheck, 700);
    }

    onExternalVariantId(rawId) {
      if (this._settingVariantId) return; // our own write — ignore
      const id = String(rawId || '');
      if (!id || id === String(this._lastVariantId || '')) return;

      /* Only react to ids we actually own (a variant of one of the styles). */
      let owner = null;
      for (const panel of this.panels) {
        if ((panel.variants || []).some((v) => String(v.id) === id)) {
          owner = panel;
          break;
        }
      }
      if (!owner) return;

      this._lastVariantId = id; // set before applying so the poll sees equality and won't re-fire
      /* A variant change driven from Kaching's widget is a real shopper pick, so it starts the
         slider's per-style filtering just as clicking one of our own swatches would. (The
         ?variant= deep link doesn't come through here — preselectFromUrl sets the same flag
         itself, so it filters on load too.) */
      this.userInteracted = true;
      /* Reflect Kaching's choice on our UI WITHOUT writing the shared id back (the id is already
         Kaching's) — otherwise our write, incl. the transient default-variant id during the apply,
         makes Kaching re-map its other bundle slots and overwrite earlier picks. */
      this._applyingExternal = true;
      try {
        this.applyExternalSelection(owner.dataset.productId, id);
      } finally {
        this._applyingExternal = false;
      }
    }

    disconnectedCallback() {
      if (this._variantPoll) clearInterval(this._variantPoll);
      if (this._variantObserver) this._variantObserver.disconnect();
      if (this._extVariantCheck) {
        if (this.variantIdInput) {
          ['change', 'input'].forEach((evt) => this.variantIdInput.removeEventListener(evt, this._extVariantCheck));
        }
        (this._extVariantEvents || []).forEach((evt) => document.removeEventListener(evt, this._extVariantCheck));
      }
    }
  }

  if (!customElements.get('cpage-product-selector')) {
    customElements.define('cpage-product-selector', CpageProductSelector);
  }

  /* ---------- Mobile placement of the Afterpay messaging app block ----------
     The mobile header (.cps-mhead) re-renders title/price/rating above the slider and the
     originals in the info column are hidden, which leaves the Afterpay app block stranded
     down the page, away from the price it refers to. Below the mobile breakpoint we move the
     real node into the slot under the mobile price, and move it back on desktop.

     The node is moved, never cloned: Afterpay renders into a placement element with a fixed
     id, and a duplicate id would leave one of the two copies uninitialized.

     Afterpay's block can appear (or be re-rendered) after DOMContentLoaded, so a one-shot
     query would sometimes miss it. A MutationObserver on each slider re-runs the placement
     whenever nodes are added — including a late-arriving block, or one the app replaces. */
  (function () {
    const mobile = window.matchMedia('(max-width: 850px)');

    /* Prefer our own tag; fall back to the app block's generated id, which embeds the app
       handle (shopify-block-<hash>__afterpay_on_site_messaging_...). */
    function findBlock(root, key) {
      return (
        root.querySelector('[data-app-block*="' + key + '"]') ||
        root.querySelector('[id*="' + key + '"]')
      );
    }

    /* Returns true once the block exists — the caller uses that to stop watching. */
    function place(root) {
      const slot = root.querySelector('[data-mhead-slot]');
      if (!slot) return false;
      const key = slot.dataset.mheadSlot;
      let block = findBlock(root, key);
      if (!block) return false;
      /* The id fallback can land on the inner placement element rather than the app-block
         wrapper — climb to the wrapper so we move the whole block, styles included. */
      block = block.closest('.cps-appblk') || block.closest('.shopify-app-block') || block;
      if (slot.contains(block)) {
        if (!mobile.matches && block.cpsHome) {
          block.cpsHome.parent.insertBefore(block, block.cpsHome.next);
        }
        return true;
      }

      /* Remember where it started so desktop can put it back in the same spot. */
      if (!block.cpsHome) block.cpsHome = { parent: block.parentNode, next: block.nextSibling };
      if (mobile.matches) slot.appendChild(block);
      return true;
    }

    function run() {
      document.querySelectorAll('.cpslider').forEach((root) => {
        if (!place(root)) watch(root);
      });
    }

    /* The observer exists ONLY to catch a block that hasn't rendered yet, so it disconnects
       the moment one is found — from then on the matchMedia listener alone drives the moves.
       It also gives up after 15s, so a page without the Afterpay block doesn't keep a live
       observer reacting to every slide the swatch picker reorders. */
    function watch(root) {
      if (root.cpsWatching) return;
      root.cpsWatching = true;

      let queued = false;
      const stop = () => {
        observer.disconnect();
        clearTimeout(giveUp);
      };
      const observer = new MutationObserver((records) => {
        if (queued || !records.some((r) => r.addedNodes.length)) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          if (place(root)) stop();
        });
      });
      const giveUp = setTimeout(stop, 15000);
      observer.observe(root, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    window.addEventListener('load', run);
    mobile.addEventListener('change', run);
    /* The theme editor re-renders the section on every edit, replacing the markup. */
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-combined"]) return;
  try {
    
  /* ---------- Image slider ---------- */
  class CpageImageSlider extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
    }

    connectedCallback() {
      this.track = this.querySelector('[data-slider-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.allSlides = this.slides.slice();
      this.dots = Array.from(this.querySelectorAll('[data-slider-dot]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-slider-thumb]'));
      this.allThumbs = this.thumbs.slice();
      this.thumbStrip = this.querySelector('[data-slider-thumbs]');
      this.thumbPrev = this.querySelector('[data-thumb-prev]');
      this.thumbNext = this.querySelector('[data-thumb-next]');
      this.prevBtn = this.querySelector('[data-slider-prev]');
      this.nextBtn = this.querySelector('[data-slider-next]');
      this.currentIndex = 0;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!this.track || this.slides.length <= 1) return;

      this.autoplayEnabled = this.dataset.autoplay === 'true' && !this.reducedMotion;
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(this.currentIndex - 1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goTo(this.currentIndex + 1));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const visIdx = this.thumbs.indexOf(thumb);
          if (visIdx !== -1) this.goTo(visIdx);
        });
      });
      if (this.thumbPrev) this.thumbPrev.addEventListener('click', () => this.goTo(this.currentIndex - 1));
      if (this.thumbNext) this.thumbNext.addEventListener('click', () => this.goTo(this.currentIndex + 1));

      this.onScroll = this.debounce(this.handleScroll.bind(this), 60);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      this.onResize = this.debounce(() => {
        this.scrollToIndex(this.currentIndex, false);
        this.updateControls();
      }, 150);
      window.addEventListener('resize', this.onResize);

      /* Touch swipe — one slide per swipe, touch devices only */
      this.isTouch = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
      if (this.isTouch) {
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);
        this.track.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.track.addEventListener('touchend', this.onTouchEnd, { passive: true });
      }

      if (this.autoplayEnabled) {
        this.startAutoplay();
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());
      }
      this.update();
      this.updateControls();
      /* Image dimensions can change the overflow after load — recalc once ready */
      this.onLoad = () => this.updateControls();
      window.addEventListener('load', this.onLoad);
    }

    disconnectedCallback() {
      this.stopAutoplay();
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      if (this.onLoad) window.removeEventListener('load', this.onLoad);
    }

    goTo(index) {
      const count = this.slides.length;
      if (!count) return;
      if (index < 0) index = count - 1;
      if (index >= count) index = 0;
      this.currentIndex = index;
      this.scrollToIndex(index, true);
      this.update();
    }

    scrollToImageId(imageId) {
      if (!this.track) return false;
      const idx = this.slides.findIndex((s) => s.dataset.imageId === String(imageId));
      if (idx === -1) return false;
      this.goTo(idx);
      return true;
    }

    scrollToProductId(productId) {
      if (!this.track) return false;
      const idx = this.slides.findIndex((s) => s.dataset.productId === String(productId));
      if (idx === -1) return false;
      this.goTo(idx);
      return true;
    }

    /* Show the selected product's slides plus the always-present lifestyle slides. Only
       called once the shopper has picked a style — until then every slide stays visible in
       its rendered order (lifestyle images first). `lifestyleFirst` leads with the lifestyle
       images instead of trailing them. Slides/thumbs are physically reordered so the
       scroll-index math (index * clientWidth) stays correct. */
    filterByProductId(productId, lifestyleFirst) {
      if (!this.track || !this.allSlides) return;
      const pid = String(productId);
      const isLifestyle = (el) => el.dataset.lifestyle === 'true';

      const productSlides = this.allSlides.filter((s) => s.dataset.productId === pid);
      const lifestyleSlides = this.allSlides.filter(isLifestyle);
      const ordered = lifestyleFirst
        ? lifestyleSlides.concat(productSlides)
        : productSlides.concat(lifestyleSlides);
      const visible = new Set(ordered);

      this.allSlides.forEach((slide) => {
        const show = visible.has(slide);
        slide.style.flex = show ? '' : '0 0 0%';
        slide.style.minWidth = show ? '' : '0';
        slide.style.overflow = show ? '' : 'hidden';
        slide.style.scrollSnapAlign = show ? '' : 'none';
      });
      ordered.forEach((slide) => this.track.appendChild(slide));
      this.slides = ordered;

      if (this.allThumbs && this.thumbStrip) {
        const orderedThumbs = ordered
          .map((s) => this.allThumbs[this.allSlides.indexOf(s)])
          .filter(Boolean);
        const visThumbs = new Set(orderedThumbs);
        this.allThumbs.forEach((thumb) => { thumb.hidden = !visThumbs.has(thumb); });
        orderedThumbs.forEach((thumb) => this.thumbStrip.appendChild(thumb));
        this.thumbs = orderedThumbs;
      }

      this.currentIndex = 0;
      this.track.scrollTo({ left: 0, behavior: 'auto' });
      this.update();
      this.updateControls();
    }

    scrollToIndex(index, smooth) {
      this.track.scrollTo({
        left: index * this.track.clientWidth,
        behavior: smooth && !this.reducedMotion ? 'smooth' : 'auto',
      });
    }

    handleScroll() {
      const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
      if (index !== this.currentIndex) {
        this.currentIndex = index;
        this.update();
      }
    }

    /* Arrows are only needed when the visible slides actually overflow the track */
    needsArrows() {
      if (!this.track || this.slides.length <= 1) return false;
      return this.track.scrollWidth - this.track.clientWidth > 1;
    }

    updateControls() {
      const need = this.needsArrows();
      if (this.prevBtn) this.prevBtn.hidden = !need;
      if (this.nextBtn) this.nextBtn.hidden = !need;

      const strip = this.thumbStrip;
      const thumbNeed = this.thumbs.length > 1 && strip && strip.scrollWidth - strip.clientWidth > 1;
      if (this.thumbPrev) this.thumbPrev.hidden = !thumbNeed;
      if (this.thumbNext) this.thumbNext.hidden = !thumbNeed;
    }

    onTouchStart(e) {
      const t = e.changedTouches[0];
      this.touchStartX = t.clientX;
      this.touchStartY = t.clientY;
      this.swipeStartIndex = this.currentIndex;
      this.stopAutoplay();
    }

    onTouchEnd(e) {
      if (this.touchStartX == null) return;
      const t = e.changedTouches[0];
      const dx = t.clientX - this.touchStartX;
      const dy = t.clientY - this.touchStartY;
      this.touchStartX = null;
      /* Horizontal swipe past the threshold → advance exactly one slide */
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        this.goTo(this.swipeStartIndex + (dx < 0 ? 1 : -1));
      }
      if (this.autoplayEnabled) this.startAutoplay();
    }

    update() {
      this.dots.forEach((dot, i) => {
        const active = i === this.currentIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      this.thumbs.forEach((thumb, i) => {
        const active = i === this.currentIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      const activeThumb = this.thumbs[this.currentIndex];
      if (activeThumb && this.thumbStrip) {
        /* Reveal the active thumb by scrolling the strip horizontally only — never
           scrollIntoView, which also scrolls the page (and on load jumped the whole
           page down to the strip when it sat below the fold). */
        const strip = this.thumbStrip;
        const stripRect = strip.getBoundingClientRect();
        const thumbRect = activeThumb.getBoundingClientRect();
        const delta = thumbRect.left - stripRect.left - (stripRect.width - thumbRect.width) / 2;
        strip.scrollBy({ left: delta, behavior: this.reducedMotion ? 'auto' : 'smooth' });
      }
    }

    startAutoplay() {
      if (!this.autoplayEnabled) return;
      this.stopAutoplay();
      this.timer = setInterval(() => this.goTo(this.currentIndex + 1), this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }

  if (!customElements.get('cpage-image-slider')) {
    customElements.define('cpage-image-slider', CpageImageSlider);
  }

  /* ---------- Product selector ---------- */
  class CpageProductSelector extends HTMLElement {
    connectedCallback() {
      this.swatches = Array.from(this.querySelectorAll('[data-swatch]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.selectedTitle = this.querySelector('[data-selected-title]');
      this.addButton = this.querySelector('[data-add-to-cart]');
      /* Combined-listing / product page: add-to-cart is a real Shopify product form so
         the theme's product-form-component (AJAX add + cart drawer) and cart/bundle apps
         like Kaching can hook it. We keep the form's hidden variant id in sync with the
         selected style; the form submit — not a custom fetch — performs the add. */
      this.cartForm = this.querySelector('[data-cps-form], form[action*="/cart/add"]');
      this.variantIdInput = this.querySelector('[data-cps-variant-id]');
      /* AJAX cart mode (section setting) — we perform the add ourselves so cart-drawer apps
         like UpCart open their drawer instead of the page navigating to /cart. */
      this.ajaxCart = !!(this.cartForm && this.cartForm.dataset.cpsCart === 'ajax');
      if (this.ajaxCart) {
        this.cartForm.addEventListener('submit', (e) => { e.preventDefault(); this.ajaxAdd(); });
      }

      if (this.swatches.length === 0) return;

      const wrapper = this.closest('.cpslider');
      this.slider = wrapper ? wrapper.querySelector('cpage-image-slider') : null;
      this.abSwatchImages = wrapper && wrapper.hasAttribute('data-ab-swatches') ? wrapper.cpsAbImages || null : null;

      /* Tracks whether the shopper has actively picked a style yet. Drives lifestyle-image
         ordering in the slider: false → lifestyle images lead; true → they trail. */
      this.userInteracted = false;
      this.swatches.forEach((sw) => sw.addEventListener('click', () => { this.userInteracted = true; this.selectProduct(sw); }));
      this.addEventListener('keydown', (e) => this.onKeydown(e));
      this.panels.forEach((panel) => this.initPanel(panel));

      if (this.addButton) {
        this.setupButtonColors();
        /* The product form's native submit (theme's product-form-component, also hooked by
           Kaching) performs the add — we don't fetch. But we still reflect adding → added on
           the button for UX. The click fires for both paths; we never call preventDefault or
           set the disabled attribute (that could block the submit), only visual state. */
        /* capture phase so our visual state fires even if Kaching stops bubble propagation */
        this.addButton.addEventListener('click', () => this.onAddClick(), true);
      }

      this.guide = this.querySelector('[data-size-guide]');
      if (this.guide) this.initGuide();

      this.initAccordions();
      this.initFitGuideDrawers();

      const initial = this.swatches.find((s) => s.getAttribute('aria-checked') === 'true') || this.swatches[0];
      this.selectProduct(initial, true);
      this.preselectFromUrl();
      this.initExternalVariantSync();
    }

    initPanel(panel) {
      const script = panel.querySelector('[data-variants]');
      try {
        panel.variants = script ? JSON.parse(script.textContent) : [];
      } catch {
        panel.variants = [];
      }

      panel.querySelectorAll('[data-option-value]').forEach((btn) => {
        btn.addEventListener('click', () => {
          this.userInteracted = true;
          const pos = btn.dataset.position;
          panel.querySelectorAll('[data-option-value][data-position="' + pos + '"]').forEach((sibling) => {
            const active = sibling === btn;
            sibling.classList.toggle('is-selected', active);
            sibling.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          this.updateSelectedValueDisplay(panel, pos);
          this.updateVariant(panel, true);
        });
      });

      this.updateVariant(panel, false);
    }

    updateSelectedValueDisplay(panel, position) {
      const selected = panel.querySelector('[data-option-value][data-position="' + position + '"].is-selected');
      if (selected) {
        const display = panel.querySelector('[data-selected-value-' + position + ']');
        if (display) {
          /* Fake-combined mode puts the REAL option value in data-value ("Prime / Polar")
             and the short shopper-facing name in data-label ("Polar"). */
          display.textContent = selected.dataset.label || selected.dataset.value;
        }
      }
    }

    getSelectedOptions(panel) {
      const options = [];
      panel.querySelectorAll('[data-option-position]').forEach((group) => {
        const pos = parseInt(group.dataset.optionPosition, 10);
        const selected = group.querySelector('[data-option-value].is-selected');
        if (selected) options[pos - 1] = selected.dataset.value;
      });
      return options;
    }

    /* data-price lives in the buttons block (outside panels); only update when this is the active panel */
    updateVariant(panel, fromUser) {
      const variants = panel.variants || [];
      if (variants.length) {
        const selected = this.getSelectedOptions(panel);
        let match = variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
        if (!match) match = variants[0];
        panel.currentVariant = match;
      }

      this.updateSwatchImage(panel);

      if (panel === this.activePanel) {
        const v = panel.currentVariant;
        const priceEl = this.querySelector('[data-price]');
        if (priceEl) {
          priceEl.textContent = v ? v.price + (v.available === false ? ' · Sold out' : '') : '';
        }
        /* Compare-at price: only shown when the variant is actually discounted */
        const compareEl = this.querySelector('[data-compare-price]');
        if (compareEl) {
          const compare = v && v.compare_at_price;
          compareEl.textContent = compare || '';
          compareEl.hidden = !compare;
        }
        this.updateAddToCart();
        /* For listeners outside the selector (the bpb bundle picker's pair 1). */
        this.dispatchEvent(new CustomEvent('cps:variant-change', { bubbles: true, detail: { variant: v, fromUser: !!fromUser } }));
      }

      if (fromUser) this.syncSlider(panel);
    }

    /* Point a style/brand swatch at the image of the variant currently selected inside its
       panel, so picking a colour re-skins the swatch. Variants without their own image fall
       back to the product's featured image captured in data-default-src. */
    updateSwatchImage(panel) {
      const swatch = this.swatches.find((s) => s.dataset.index === panel.dataset.index);
      const img = swatch && swatch.querySelector('[data-swatch-img]');
      if (!img) return;
      const variant = panel.currentVariant;
      /* A/B gallery (snippets/ab-gallery-slider): image_id → override, when swatches opt in */
      const ab = this.abSwatchImages && variant && variant.image_id != null ? this.abSwatchImages[variant.image_id] : null;
      const next = ab || (variant && variant.image) || img.dataset.defaultSrc;
      /* compare the attribute, not img.src — the latter is resolved to an absolute URL */
      if (next && img.getAttribute('src') !== next) img.setAttribute('src', next);
    }
    
    selectProduct(swatch, silent) {
      const index = swatch.dataset.index;

      this.swatches.forEach((s) => {
        const active = s === swatch;
        s.classList.toggle('is-selected', active);
        s.setAttribute('aria-checked', active ? 'true' : 'false');
        s.tabIndex = active ? 0 : -1;
      });

      this.activePanel = null;
      this.panels.forEach((panel) => {
        const active = panel.dataset.index === index;
        panel.hidden = !active;
        if (active) this.activePanel = panel;
      });

      this.querySelectorAll('[data-selected-title]').forEach((el) => {
        el.textContent = swatch.dataset.title || '';
      });

      this.updateFitGuideImages(index);

      /* "Available Size" card — concise band for the selected style; hidden when unknown */
      const availEl = this.querySelector('[data-avail-size]');
      const bandEl = this.querySelector('[data-size-band-text]');
      const band = swatch.dataset.sizeBand || '';
      if (bandEl) bandEl.textContent = band;
      if (availEl) availEl.hidden = !band;

      /* updateVariant handles both price refresh and updateAddToCart for the active panel */
      if (this.activePanel) this.updateVariant(this.activePanel, false);
      else this.updateAddToCart();

      /* Filter the slider to the selected product, but only once the shopper has
         interacted — the initial (silent) selection leaves every image on show. */
      this.syncSlider(this.activePanel);
      /* Move focus for keyboard/a11y, but never scroll the page to the swatch — the
         default focus() scroll-into-view was jumping the page on select. */
      if (!silent) {
        swatch.focus({ preventScroll: true });
        /* Blur after a short delay so the tooltip (shown on :focus-visible) disappears */
        requestAnimationFrame(() => swatch.blur());
      }
    }

    syncSlider(panel) {
      if (!this.slider || !panel) return;
      /* On page load the slider shows everything — every style's images, led by the
         lifestyle images — so the shopper sees the full range before choosing. Filtering
         to a single style only begins at the first swatch/option/keyboard pick. */
      if (!this.userInteracted) return;
      /* The slider element may not have upgraded/connected yet (e.g. image column
         positioned right renders after this selector). Retry once it's ready. */
      if (!this.slider.track) {
        if (!this._syncRetried) {
          this._syncRetried = true;
          requestAnimationFrame(() => this.syncSlider(panel));
        }
        return;
      }
      this._syncRetried = false;
      /* Once filtering, the lifestyle images trail the selected style's own images. */
      this.slider.filterByProductId(panel.dataset.productId, false);
      const variant = panel.currentVariant;
      if (variant && variant.image_id != null) {
        this.slider.scrollToImageId(variant.image_id);
      }
    }

    updateAddToCart() {
      if (!this.addButton) return;
      const variant = this.activePanel && this.activePanel.currentVariant;
      const soldOut = variant && variant.available === false;
      this.addButton.disabled = !variant || soldOut;

      /* Keep the product form's hidden variant id in sync with the selected style so the
         native form submit (and any cart/bundle app hooking it) adds the right variant.
         Disabled inputs aren't submitted, so we also gate it on availability. */
      if (this.variantIdInput && !this._applyingExternal) {
        /* While applying a selection that CAME FROM Kaching (_applyingExternal), the shared id
           is already what Kaching set — writing it back (incl. the transient default-variant id
           mid-apply) makes Kaching re-map all its bundle slots and clobber other picks. So we
           only sync the id for our own selections here.
           Flag this as our own write so the watcher doesn't mistake it for a customer change and
           loop. _lastVariantId tracks the value we last put there, compared in onExternalVariantId. */
        this._settingVariantId = true;
        if (variant && !soldOut) {
          this.variantIdInput.value = variant.id;
          this.variantIdInput.disabled = false;
          this._lastVariantId = String(variant.id);
        } else {
          this.variantIdInput.value = '';
          this.variantIdInput.disabled = true;
          this._lastVariantId = '';
        }
        this._settingVariantId = false;
      }

      if (soldOut) {
        this.addButton.textContent = this.addButton.dataset.soldOutLabel || 'Sold out';
        return;
      }
      let label = this.addButton.dataset.addLabel || 'Add to cart';
      /* optionally show the live variant price in the button, e.g. "Add to cart · $70.00" */
      if (this.addButton.dataset.showPrice === 'true' && variant && variant.price) {
        label += (this.addButton.dataset.priceSeparator || ' · ') + variant.price;
      }
      this.addButton.textContent = label;
    }

    /* ---- Add-to-cart visual state (the form/Kaching do the actual add) ---- */
    onAddClick() {
      const variant = this.activePanel && this.activePanel.currentVariant;
      /* sold out / no variant → button is disabled and won't submit; nothing to show */
      if (!variant || variant.available === false) return;
      this.startAdding();
    }

    /* AJAX add (portable cart mode): post to /cart/add.js, then notify cart-drawer apps/themes.
       UpCart also intercepts this fetch directly, which is what opens its drawer. */
    ajaxAdd() {
      const variant = this.activePanel && this.activePanel.currentVariant;
      if (!variant || variant.available === false) return;
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      this.startAdding();
      clearTimeout(this._addingTimer); // the real fetch drives completion, not the fallback timer
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }),
      })
        .then((r) => r.json())
        .then((data) => {
          if (data && data.status) throw new Error(data.description || 'add failed');
          this.markAdded();
          this.notifyCart();
        })
        .catch(() => {
          this._adding = false;
          if (this.addButton) this.addButton.classList.remove('is-loading');
          this.updateAddToCart();
        });
    }

    notifyCart() {
      /* Broadcast widely so whatever cart drawer is present refreshes/opens (theme- and
         app-agnostic). UpCart hooks the fetch above; these cover native theme drawers. */
      ['cart:refresh', 'cart:updated', 'cart:change', 'ajaxProduct:added', 'product:added'].forEach((name) =>
        document.dispatchEvent(new CustomEvent(name, { bubbles: true }))
      );
      try {
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'cpslider' });
        }
      } catch (e) {}
    }

    startAdding() {
      if (!this.addButton || this._adding) return;
      this._adding = true;
      /* capture the live text colour so the spinner is visible once we hide the label */
      this.addButton.style.setProperty('--cps-spin', getComputedStyle(this.addButton).color);
      this.addButton.classList.remove('is-added');
      this.addButton.classList.add('is-loading');
      clearTimeout(this._addedTimer);
      clearTimeout(this._addingTimer);
      /* We don't get a reliable completion signal across the theme form + Kaching + UpCart,
         so show the spinner briefly, then confirm with "Added". */
      this._addingTimer = setTimeout(() => this.markAdded(), 1000);
    }

    markAdded() {
      if (!this.addButton || !this._adding) return;
      this._adding = false;
      clearTimeout(this._addingTimer);
      this.addButton.classList.remove('is-loading');
      this.addButton.classList.add('is-added');
      this.addButton.textContent = this.addButton.dataset.addedLabel || 'Added';
      clearTimeout(this._addedTimer);
      this._addedTimer = setTimeout(() => {
        this.addButton.classList.remove('is-added');
        this.updateAddToCart();
      }, 1800);
    }

    addToCart() {
      const variant = this.activePanel && this.activePanel.currentVariant;
      if (!variant || variant.available === false) return;

      const root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
      this.addButton.classList.add('is-loading');
      this.addButton.disabled = true;

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }),
      })
        .then((r) => r.json())
        .then(() => {
          this.addButton.classList.remove('is-loading');
          document.dispatchEvent(new CustomEvent('cart:added', { bubbles: true, detail: { id: variant.id } }));
          this.flashAdded();
          this.openCartDrawer(root);
        })
        .catch(() => {
          this.addButton.classList.remove('is-loading');
          this.updateAddToCart();
        });
    }

    openCartDrawer(root) {
      const SECTION = 'cart-drawer-section';
      fetch((root || '/') + '?sections=' + SECTION)
        .then((r) => r.json())
        .then((data) => {
          const html = data[SECTION];
          if (html) {
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const fresh = parsed.getElementById('shopify-section-' + SECTION);
            const current = document.getElementById('shopify-section-' + SECTION);
            if (fresh && current) current.innerHTML = fresh.innerHTML;
          }
        })
        .catch(() => {})
        .finally(() => {
          const drawer = document.querySelector('theme-drawer#cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          } else if (window.Shopify?.actions?.openCart) {
            window.Shopify.actions.openCart();
          } else {
            window.location.href = root + 'cart';
          }
        });
    }

    flashAdded() {
      this.addButton.disabled = false;
      this.addButton.textContent = this.addButton.dataset.addedLabel || 'Added';
      clearTimeout(this.addedTimer);
      this.addedTimer = setTimeout(() => this.updateAddToCart(), 1800);
    }

    setupButtonColors() {
      const fg = getComputedStyle(this).color;
      const parts = fg.match(/\d+(\.\d+)?/g);
      if (!parts) return;
      const luminance = (0.299 * Number(parts[0]) + 0.587 * Number(parts[1]) + 0.114 * Number(parts[2])) / 255;
      this.style.setProperty('--cps-btn-bg', fg);
      this.style.setProperty('--cps-btn-fg', luminance < 0.55 ? '#ffffff' : '#111111');
    }

    onKeydown(e) {
      const keys = ['ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
      if (!keys.includes(e.key)) return;
      const current = this.swatches.findIndex((s) => s.getAttribute('aria-checked') === 'true');
      if (current === -1) return;
      e.preventDefault();
      const last = this.swatches.length - 1;
      let next = current;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = current === last ? 0 : current + 1;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = current === 0 ? last : current - 1;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = last;
      this.userInteracted = true;
      this.selectProduct(this.swatches[next]);
    }

    /* ---------- Size guide ---------- */
    initGuide() {
      this.guideOpeners = Array.from(this.querySelectorAll('[data-size-guide-open]'));
      this.guideOpeners.forEach((btn) => btn.addEventListener('click', () => this.openGuide(btn)));

      this.guide
        .querySelectorAll('[data-size-guide-close]')
        .forEach((el) => el.addEventListener('click', () => this.closeGuide(true)));
      const ok = this.guide.querySelector('[data-size-guide-ok]');
      if (ok) ok.addEventListener('click', () => this.closeGuide(true));

      this.guide.querySelectorAll('[data-bucket-toggle]').forEach((btn) =>
        btn.addEventListener('click', () => {
          const bucket = btn.closest('[data-bucket]');
          if (!bucket) return;
          const willOpen = !bucket.classList.contains('is-open');
          this.guide.querySelectorAll('[data-bucket]').forEach((b) => {
            b.classList.remove('is-open');
            const h = b.querySelector('[data-bucket-toggle]');
            if (h) h.setAttribute('aria-expanded', 'false');
          });
          if (willOpen) {
            bucket.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          }
        })
      );

      this.guide.querySelectorAll('[data-colors-more]').forEach((btn) =>
        btn.addEventListener('click', () => {
          const wrap = btn.closest('[data-colors]');
          if (wrap) wrap.classList.add('is-expanded');
        })
      );

      this.guideColors = Array.from(this.guide.querySelectorAll('[data-guide-color]'));
      this.guideColors.forEach((btn) => btn.addEventListener('click', () => this.setGuidePending(btn)));

      this.guide.querySelectorAll('[data-guide-card]').forEach((card) => {
        card.addEventListener('click', (e) => {
          if (e.target.closest('[data-guide-color]')) return;
          const firstColor = card.querySelector('[data-guide-color]');
          if (firstColor) this.setGuidePending(firstColor);
        });
      });

      this.onGuideKeydown = (e) => {
        if (e.key === 'Escape') this.closeGuide(true);
      };
    }

    openGuide(trigger) {
      if (!this.guide) return;
      this.guideTrigger = trigger || null;
      this.guidePending = null;

      this.guideColors.forEach((b) => b.classList.remove('is-selected'));
      this.guide.querySelectorAll('[data-guide-thumb]').forEach((img) => {
        if (img.dataset.defaultSrc) img.src = img.dataset.defaultSrc;
      });
      this.guide.querySelectorAll('[data-bucket]').forEach((b) => {
        b.classList.remove('is-open');
        const h = b.querySelector('[data-bucket-toggle]');
        if (h) h.setAttribute('aria-expanded', 'false');
      });
      this.updateNiceText(null);

      clearTimeout(this._guideHideTimer);
      this.guide.hidden = false;
      /* two frames so the panel paints off-screen before the drawer slides in */
      requestAnimationFrame(() => requestAnimationFrame(() => this.guide.classList.add('is-open')));
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onGuideKeydown);
      const dialog = this.guide.querySelector('.cpsg__dialog');
      if (dialog) dialog.focus();
    }

    closeGuide(commit) {
      if (!this.guide) return;
      if (commit && this.guidePending) {
        this.applyExternalSelection(this.guidePending.productId, this.guidePending.variantId);
      }
      this.guide.classList.remove('is-open');
      /* drawer variant slides out — wait for the transition before hiding; modal hides at once */
      const isDrawer = this.guide.classList.contains('cpsg--drawer');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (isDrawer && !reduced) {
        clearTimeout(this._guideHideTimer);
        this._guideHideTimer = setTimeout(() => { this.guide.hidden = true; }, 320);
      } else {
        this.guide.hidden = true;
      }
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', this.onGuideKeydown);
      if (this.guideTrigger && typeof this.guideTrigger.focus === 'function') this.guideTrigger.focus();
    }

    setGuidePending(button) {
      this.guideColors.forEach((b) => b.classList.toggle('is-selected', b === button));
      this.guidePending = { productId: button.dataset.productId, variantId: button.dataset.variantId };
      this.updateNiceText(button);
      this.updateGuideCardImage(button);
    }

    /* Show the selected colour's variant image; fall back to the card's main image */
    updateGuideCardImage(button) {
      const card = button.closest('[data-guide-card]');
      if (!card) return;
      const img = card.querySelector('[data-guide-thumb]');
      if (!img) return;
      const variantImage = button.dataset.variantImage;
      img.src = variantImage || img.dataset.defaultSrc || img.src;
    }

    updateNiceText(button) {
      const niceText = this.guide && this.guide.querySelector('[data-guide-nice-text]');
      const nameEl = this.guide && this.guide.querySelector('[data-guide-selected-name]');
      if (!niceText || !nameEl) return;
      const title = button && button.dataset.productTitle;
      if (title) {
        nameEl.textContent = title;
        niceText.hidden = false;
      } else {
        niceText.hidden = true;
      }
    }

    initAccordions() {
      this.querySelectorAll('[data-accordion-head]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const item = btn.closest('[data-accordion]');
          if (!item) return;
          const isOpen = item.classList.contains('is-open');
          item.classList.toggle('is-open', !isOpen);
          btn.setAttribute('aria-expanded', String(!isOpen));
        });
      });
    }

    /* Swap the fitting-guide drawer images to the selected product's metafield images.
       Falls back to the block's default image when a product has none. */
    updateFitGuideImages(index) {
      const boxes = this.querySelectorAll('[data-fitguide-images]');
      if (!boxes.length) return;
      boxes.forEach((box) => {
        const container = box.closest('[data-fitguide]');
        if (!container) return;
        if (container._fitMap === undefined) {
          const script = container.querySelector('[data-fitguide-map]');
          try {
            container._fitMap = script ? JSON.parse(script.textContent) : {};
          } catch {
            container._fitMap = {};
          }
        }
        const map = container._fitMap || {};
        let urls = map[index] || [];
        if (!urls.length && box.dataset.defaultImage) urls = [box.dataset.defaultImage];
        box.innerHTML = urls
          .map((u) => {
            const s = this.fitImageSrc(u);
            // Wrapper clips the scaled image so zoom stays inside the drawer (no lightbox).
            return `<div class="cpfg-drawer__zoom" data-fitguide-zoom><img class="cpfg-drawer__image" src="${s.src}" srcset="${s.srcset}" sizes="(max-width: 500px) 92vw, 820px" alt="" loading="lazy" decoding="async"></div>`;
          })
          .join('');
        this.wireFitZoom(box);
      });
    }

    // Build a responsive srcset from a Shopify CDN image URL by varying the `width` param, and
    // request a generously-sized default so the fitting guide reads sharp (incl. when zoomed).
    fitImageSrc(url) {
      if (!url) return { src: '', srcset: '' };
      let base = url;
      try {
        const u = new URL(url, document.baseURI);
        u.searchParams.delete('width');
        u.searchParams.delete('height');
        base = u.href;
      } catch (e) {
        base = url.replace(/[?&](width|height)=\d+/g, '').replace(/[?&]$/, '');
      }
      const sep = base.includes('?') ? '&' : '?';
      const widths = [480, 768, 1080, 1440, 1920];
      const srcset = widths.map((w) => `${base}${sep}width=${w} ${w}w`).join(', ');
      return { src: `${base}${sep}width=1080`, srcset };
    }

    // In-drawer image zoom: hover shows a zoom-in cursor; click zooms (scaled, clipped inside the
    // drawer — not a lightbox); moving the pointer while zoomed pans; a held drag doesn't exit zoom.
    wireFitZoom(scope) {
      const ZOOM = 2.4;
      const DRAG = 6; // px moved since pointerdown that counts as a drag/pan, not a click
      scope.querySelectorAll('[data-fitguide-zoom]').forEach((box) => {
        const img = box.querySelector('img');
        if (!img) return;
        img.style.setProperty('--cpfg-zoom', ZOOM);
        let zoomed = false;
        let startX = 0;
        let startY = 0;
        let moved = false;
        const panTo = (clientX, clientY) => {
          const r = box.getBoundingClientRect();
          const px = Math.min(1, Math.max(0, (clientX - r.left) / r.width));
          const py = Math.min(1, Math.max(0, (clientY - r.top) / r.height));
          img.style.transformOrigin = `${px * 100}% ${py * 100}%`;
        };
        box.addEventListener('pointerdown', (e) => {
          startX = e.clientX;
          startY = e.clientY;
          moved = false;
        });
        box.addEventListener('pointermove', (e) => {
          if (!moved && Math.hypot(e.clientX - startX, e.clientY - startY) > DRAG) moved = true;
          if (zoomed) panTo(e.clientX, e.clientY);
        });
        box.addEventListener('click', (e) => {
          // A drag (holding + moving to pan) fires a click on release — ignore it so zoom stays.
          if (moved) {
            moved = false;
            return;
          }
          zoomed = !zoomed;
          if (zoomed) panTo(e.clientX, e.clientY);
          box.classList.toggle('is-zoomed', zoomed);
        });
        box.addEventListener('pointerleave', () => {
          if (!zoomed) return;
          zoomed = false;
          box.classList.remove('is-zoomed');
        });
      });
    }

    /* ---------- Fitting-guide drawer (right on desktop, bottom sheet on mobile) ---------- */
    initFitGuideDrawers() {
      const triggers = Array.from(this.querySelectorAll('[data-fitguide-open]'));
      if (!triggers.length) return;

      this.openFitDrawerEl = null;
      this.fitTrigger = null;
      this.onFitKeydown = (e) => {
        if (e.key === 'Escape' && this.openFitDrawerEl) this.closeFitDrawer(this.openFitDrawerEl);
      };

      triggers.forEach((btn) => {
        /* The trigger card lives in the swatches block, so resolve its drawer by the
           target id it points at; fall back to an ancestor [data-fitguide] container. */
        let container = null;
        if (btn.dataset.fitguideTarget) container = document.getElementById(btn.dataset.fitguideTarget);
        if (!container) container = btn.closest('[data-fitguide]');
        const drawer = container && container.querySelector('[data-fitguide-drawer]');
        if (!drawer) return;
        btn.addEventListener('click', () => this.openFitDrawer(btn, drawer));
        drawer
          .querySelectorAll('[data-fitguide-close]')
          .forEach((el) => el.addEventListener('click', () => this.closeFitDrawer(drawer)));
      });
    }

    openFitDrawer(trigger, drawer) {
      this.fitTrigger = trigger;
      this.openFitDrawerEl = drawer;
      drawer.hidden = false;
      /* Two frames so the panel paints in its off-screen state before transitioning in */
      requestAnimationFrame(() => requestAnimationFrame(() => drawer.classList.add('is-open')));
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onFitKeydown);
      trigger.setAttribute('aria-expanded', 'true');
      const panel = drawer.querySelector('.cpfg-drawer__panel');
      if (panel) panel.focus();
    }

    closeFitDrawer(drawer) {
      drawer.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', this.onFitKeydown);

      const panel = drawer.querySelector('.cpfg-drawer__panel');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (panel && !reduced) {
        let done = false;
        const finish = () => {
          if (done) return;
          done = true;
          panel.removeEventListener('transitionend', finish);
          drawer.hidden = true;
        };
        panel.addEventListener('transitionend', finish);
        setTimeout(finish, 400);
      } else {
        drawer.hidden = true;
      }

      if (this.fitTrigger) {
        this.fitTrigger.setAttribute('aria-expanded', 'false');
        this.fitTrigger.focus();
      }
      this.openFitDrawerEl = null;
    }

    preselectFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const vid = params.get('variant') || params.get('fyf_variant');
      if (!vid) return;
      for (const panel of this.panels) {
        if ((panel.variants || []).some((v) => String(v.id) === String(vid))) {
          this.applyExternalSelection(panel.dataset.productId, vid);
          return;
        }
      }
    }

    applyExternalSelection(productId, variantId) {
      /* Resolve the owning panel from the VARIANT id first. In fake-combined mode every panel
         is a slice of the same product, so data-product-id is identical across styles and the
         old product-id lookup always landed on the first swatch — which then had no matching
         variant, so Kaching's pick never reflected. Variant ids are unique across panels, so
         they identify the style exactly. Fall back to the product id for a real combined
         listing, or when the caller has no variant id to go on. */
      let owner = null;
      if (variantId != null && variantId !== '') {
        owner =
          this.panels.find((p) => (p.variants || []).some((v) => String(v.id) === String(variantId))) || null;
      }
      const swatch = owner
        ? this.swatches.find((s) => s.dataset.index === owner.dataset.index)
        : this.swatches.find((s) => s.dataset.productId === String(productId));
      if (swatch) this.selectProduct(swatch, true);

      const panel = this.activePanel;
      if (!panel) return;

      const target = (panel.variants || []).find((v) => String(v.id) === String(variantId));
      if (target && Array.isArray(target.options)) {
        panel.querySelectorAll('[data-option-position]').forEach((group) => {
          const pos = parseInt(group.dataset.optionPosition, 10);
          const want = target.options[pos - 1];
          group.querySelectorAll('[data-option-value]').forEach((btn) => {
            const active = btn.dataset.value === want;
            btn.classList.toggle('is-selected', active);
            btn.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          this.updateSelectedValueDisplay(panel, pos);
        });
      }

      this.updateVariant(panel, true);
    }

    /* ---- External selection sync (Kaching bundles / any app-driven variant change) ----
       Our swatch normally drives the shared form's hidden variant id (updateAddToCart). When
       Kaching lets the customer switch variant/style in its own widget, it changes that same
       id. We watch it for changes we didn't make and move the swatch (+ reflect the exact
       variant's options) to match, reusing applyExternalSelection.

       Kaching's write mechanism isn't known, so we cover them all: bubbling change/input
       events, common variant pub-sub events, attribute mutations, and a cheap safety-net poll
       for property-only writes (input.value = … fires no event and doesn't touch the
       attribute). Every path funnels through onExternalVariantId, which no-ops unless the id
       genuinely changed to one of our variants. */
    initExternalVariantSync() {
      if (!this.variantIdInput) return;
      if (this._lastVariantId == null) this._lastVariantId = String(this.variantIdInput.value || '');

      this._extVariantCheck = () => this.onExternalVariantId(this.variantIdInput.value);

      ['change', 'input'].forEach((evt) => this.variantIdInput.addEventListener(evt, this._extVariantCheck));
      this._extVariantEvents = ['variant:change', 'variantChange', 'product:variant-change', 'on:variant:change'];
      this._extVariantEvents.forEach((evt) => document.addEventListener(evt, this._extVariantCheck));

      try {
        this._variantObserver = new MutationObserver(this._extVariantCheck);
        this._variantObserver.observe(this.variantIdInput, { attributes: true, attributeFilter: ['value'] });
      } catch (e) {}

      this._variantPoll = setInterval(this._extVariantCheck, 700);
    }

    onExternalVariantId(rawId) {
      if (this._settingVariantId) return; // our own write — ignore
      const id = String(rawId || '');
      if (!id || id === String(this._lastVariantId || '')) return;

      /* Only react to ids we actually own (a variant of one of the styles). */
      let owner = null;
      for (const panel of this.panels) {
        if ((panel.variants || []).some((v) => String(v.id) === id)) {
          owner = panel;
          break;
        }
      }
      if (!owner) return;

      this._lastVariantId = id; // set before applying so the poll sees equality and won't re-fire
      /* A variant change driven from Kaching's widget is a real shopper pick, so it starts the
         slider's per-style filtering just as clicking one of our own swatches would. (The
         ?variant= deep link reaches applyExternalSelection without going through here, so it
         still leaves the unfiltered on-load gallery intact.) */
      this.userInteracted = true;
      /* Reflect Kaching's choice on our UI WITHOUT writing the shared id back (the id is already
         Kaching's) — otherwise our write, incl. the transient default-variant id during the apply,
         makes Kaching re-map its other bundle slots and overwrite earlier picks. */
      this._applyingExternal = true;
      try {
        this.applyExternalSelection(owner.dataset.productId, id);
      } finally {
        this._applyingExternal = false;
      }
    }

    disconnectedCallback() {
      if (this._variantPoll) clearInterval(this._variantPoll);
      if (this._variantObserver) this._variantObserver.disconnect();
      if (this._extVariantCheck) {
        if (this.variantIdInput) {
          ['change', 'input'].forEach((evt) => this.variantIdInput.removeEventListener(evt, this._extVariantCheck));
        }
        (this._extVariantEvents || []).forEach((evt) => document.removeEventListener(evt, this._extVariantCheck));
      }
    }
  }

  if (!customElements.get('cpage-product-selector')) {
    customElements.define('cpage-product-selector', CpageProductSelector);
  }

  /* ---------- Mobile placement of the Afterpay messaging app block ----------
     The mobile header (.cps-mhead) re-renders title/price/rating above the slider and the
     originals in the info column are hidden, which leaves the Afterpay app block stranded
     down the page, away from the price it refers to. Below the mobile breakpoint we move the
     real node into the slot under the mobile price, and move it back on desktop.

     The node is moved, never cloned: Afterpay renders into a placement element with a fixed
     id, and a duplicate id would leave one of the two copies uninitialized.

     Afterpay's block can appear (or be re-rendered) after DOMContentLoaded, so a one-shot
     query would sometimes miss it. A MutationObserver on each slider re-runs the placement
     whenever nodes are added — including a late-arriving block, or one the app replaces. */
  (function () {
    const mobile = window.matchMedia('(max-width: 850px)');

    /* Prefer our own tag; fall back to the app block's generated id, which embeds the app
       handle (shopify-block-<hash>__afterpay_on_site_messaging_...). */
    function findBlock(root, key) {
      return (
        root.querySelector('[data-app-block*="' + key + '"]') ||
        root.querySelector('[id*="' + key + '"]')
      );
    }

    /* Returns true once the block exists — the caller uses that to stop watching. */
    function place(root) {
      const slot = root.querySelector('[data-mhead-slot]');
      if (!slot) return false;
      const key = slot.dataset.mheadSlot;
      let block = findBlock(root, key);
      if (!block) return false;
      /* The id fallback can land on the inner placement element rather than the app-block
         wrapper — climb to the wrapper so we move the whole block, styles included. */
      block = block.closest('.cps-appblk') || block.closest('.shopify-app-block') || block;
      if (slot.contains(block)) {
        if (!mobile.matches && block.cpsHome) {
          block.cpsHome.parent.insertBefore(block, block.cpsHome.next);
        }
        return true;
      }

      /* Remember where it started so desktop can put it back in the same spot. */
      if (!block.cpsHome) block.cpsHome = { parent: block.parentNode, next: block.nextSibling };
      if (mobile.matches) slot.appendChild(block);
      return true;
    }

    function run() {
      document.querySelectorAll('.cpslider').forEach((root) => {
        if (!place(root)) watch(root);
      });
    }

    /* The observer exists ONLY to catch a block that hasn't rendered yet, so it disconnects
       the moment one is found — from then on the matchMedia listener alone drives the moves.
       It also gives up after 15s, so a page without the Afterpay block doesn't keep a live
       observer reacting to every slide the swatch picker reorders. */
    function watch(root) {
      if (root.cpsWatching) return;
      root.cpsWatching = true;

      let queued = false;
      const stop = () => {
        observer.disconnect();
        clearTimeout(giveUp);
      };
      const observer = new MutationObserver((records) => {
        if (queued || !records.some((r) => r.addedNodes.length)) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          if (place(root)) stop();
        });
      });
      const giveUp = setTimeout(stop, 15000);
      observer.observe(root, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    window.addEventListener('load', run);
    mobile.addEventListener('change', run);
    /* The theme editor re-renders the section on every edit, replacing the markup. */
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-page-slider"] && !Shopify.designMode) return;
  try {
    
  /* ---------- Image slider ---------- */
  class CpageImageSlider extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
    }

    connectedCallback() {
      this.track = this.querySelector('[data-slider-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.allSlides = this.slides.slice();
      this.dots = Array.from(this.querySelectorAll('[data-slider-dot]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-slider-thumb]'));
      this.allThumbs = this.thumbs.slice();
      this.thumbStrip = this.querySelector('[data-slider-thumbs]');
      this.thumbPrev = this.querySelector('[data-thumb-prev]');
      this.thumbNext = this.querySelector('[data-thumb-next]');
      this.prevBtn = this.querySelector('[data-slider-prev]');
      this.nextBtn = this.querySelector('[data-slider-next]');
      this.currentIndex = 0;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!this.track || this.slides.length <= 1) return;

      this.autoplayEnabled = this.dataset.autoplay === 'true' && !this.reducedMotion;
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(this.currentIndex - 1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goTo(this.currentIndex + 1));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const visIdx = this.thumbs.indexOf(thumb);
          if (visIdx !== -1) this.goTo(visIdx);
        });
      });
      if (this.thumbPrev) this.thumbPrev.addEventListener('click', () => this.goTo(this.currentIndex - 1));
      if (this.thumbNext) this.thumbNext.addEventListener('click', () => this.goTo(this.currentIndex + 1));

      this.onScroll = this.debounce(this.handleScroll.bind(this), 60);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      this.onResize = this.debounce(() => {
        this.scrollToIndex(this.currentIndex, false);
        this.updateControls();
      }, 150);
      window.addEventListener('resize', this.onResize);

      /* Touch swipe — one slide per swipe, touch devices only */
      this.isTouch = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
      if (this.isTouch) {
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);
        this.track.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.track.addEventListener('touchend', this.onTouchEnd, { passive: true });
      }

      if (this.autoplayEnabled) {
        this.startAutoplay();
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());
      }
      this.update();
      this.updateControls();
      /* Image dimensions can change the overflow after load — recalc once ready */
      this.onLoad = () => this.updateControls();
      window.addEventListener('load', this.onLoad);
    }

    disconnectedCallback() {
      this.stopAutoplay();
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      if (this.onLoad) window.removeEventListener('load', this.onLoad);
    }

    goTo(index) {
      const count = this.slides.length;
      if (!count) return;
      if (index < 0) index = count - 1;
      if (index >= count) index = 0;
      this.currentIndex = index;
      this.scrollToIndex(index, true);
      this.update();
    }

    scrollToImageId(imageId) {
      if (!this.track) return false;
      const idx = this.slides.findIndex((s) => s.dataset.imageId === String(imageId));
      if (idx === -1) return false;
      this.goTo(idx);
      return true;
    }

    scrollToProductId(productId) {
      if (!this.track) return false;
      const idx = this.slides.findIndex((s) => s.dataset.productId === String(productId));
      if (idx === -1) return false;
      this.goTo(idx);
      return true;
    }

    filterByProductId(productId) {
      if (!this.track || !this.allSlides) return;
      const pid = String(productId);

      this.allSlides.forEach((slide) => {
        const show = slide.dataset.productId === pid;
        slide.style.flex = show ? '' : '0 0 0%';
        slide.style.minWidth = show ? '' : '0';
        slide.style.overflow = show ? '' : 'hidden';
        slide.style.scrollSnapAlign = show ? '' : 'none';
      });
      this.slides = this.allSlides.filter((s) => s.dataset.productId === pid);

      if (this.allThumbs) {
        this.allThumbs.forEach((thumb) => {
          const slide = this.allSlides[parseInt(thumb.dataset.index, 10)];
          thumb.hidden = !slide || slide.dataset.productId !== pid;
        });
        this.thumbs = this.allThumbs.filter((t) => !t.hidden);
      }

      this.currentIndex = 0;
      this.track.scrollTo({ left: 0, behavior: 'auto' });
      this.update();
      this.updateControls();
    }

    scrollToIndex(index, smooth) {
      this.track.scrollTo({
        left: index * this.track.clientWidth,
        behavior: smooth && !this.reducedMotion ? 'smooth' : 'auto',
      });
    }

    handleScroll() {
      const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
      if (index !== this.currentIndex) {
        this.currentIndex = index;
        this.update();
      }
    }

    /* Arrows are only needed when the visible slides actually overflow the track */
    needsArrows() {
      if (!this.track || this.slides.length <= 1) return false;
      return this.track.scrollWidth - this.track.clientWidth > 1;
    }

    updateControls() {
      const need = this.needsArrows();
      if (this.prevBtn) this.prevBtn.hidden = !need;
      if (this.nextBtn) this.nextBtn.hidden = !need;

      const strip = this.thumbStrip;
      const thumbNeed = this.thumbs.length > 1 && strip && strip.scrollWidth - strip.clientWidth > 1;
      if (this.thumbPrev) this.thumbPrev.hidden = !thumbNeed;
      if (this.thumbNext) this.thumbNext.hidden = !thumbNeed;
    }

    onTouchStart(e) {
      const t = e.changedTouches[0];
      this.touchStartX = t.clientX;
      this.touchStartY = t.clientY;
      this.swipeStartIndex = this.currentIndex;
      this.stopAutoplay();
    }

    onTouchEnd(e) {
      if (this.touchStartX == null) return;
      const t = e.changedTouches[0];
      const dx = t.clientX - this.touchStartX;
      const dy = t.clientY - this.touchStartY;
      this.touchStartX = null;
      /* Horizontal swipe past the threshold → advance exactly one slide */
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        this.goTo(this.swipeStartIndex + (dx < 0 ? 1 : -1));
      }
      if (this.autoplayEnabled) this.startAutoplay();
    }

    update() {
      this.dots.forEach((dot, i) => {
        const active = i === this.currentIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      this.thumbs.forEach((thumb, i) => {
        const active = i === this.currentIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      const activeThumb = this.thumbs[this.currentIndex];
      if (activeThumb && this.thumbStrip) {
        /* Reveal the active thumb by scrolling the strip horizontally only — never
           scrollIntoView, which also scrolls the page (and on load jumped the whole
           page down to the strip when it sat below the fold). */
        const strip = this.thumbStrip;
        const stripRect = strip.getBoundingClientRect();
        const thumbRect = activeThumb.getBoundingClientRect();
        const delta = thumbRect.left - stripRect.left - (stripRect.width - thumbRect.width) / 2;
        strip.scrollBy({ left: delta, behavior: this.reducedMotion ? 'auto' : 'smooth' });
      }
    }

    startAutoplay() {
      if (!this.autoplayEnabled) return;
      this.stopAutoplay();
      this.timer = setInterval(() => this.goTo(this.currentIndex + 1), this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }

  if (!customElements.get('cpage-image-slider')) {
    customElements.define('cpage-image-slider', CpageImageSlider);
  }

  /* ---------- Product selector ---------- */
  class CpageProductSelector extends HTMLElement {
    connectedCallback() {
      this.swatches = Array.from(this.querySelectorAll('[data-swatch]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.selectedTitle = this.querySelector('[data-selected-title]');
      this.addButton = this.querySelector('[data-add-to-cart]');
      /* Combined-listing / product page: add-to-cart is a real Shopify product form so
         the theme's product-form-component (AJAX add + cart drawer) and cart/bundle apps
         like Kaching can hook it. We keep the form's hidden variant id in sync with the
         selected style; the form submit — not a custom fetch — performs the add. */
      this.cartForm = this.querySelector('[data-cps-form], form[action*="/cart/add"]');
      this.variantIdInput = this.querySelector('[data-cps-variant-id]');
      /* AJAX cart mode (section setting) — we perform the add ourselves so cart-drawer apps
         like UpCart open their drawer instead of the page navigating to /cart. */
      this.ajaxCart = !!(this.cartForm && this.cartForm.dataset.cpsCart === 'ajax');
      if (this.ajaxCart) {
        this.cartForm.addEventListener('submit', (e) => { e.preventDefault(); this.ajaxAdd(); });
      }

      if (this.swatches.length === 0) return;

      const wrapper = this.closest('.cpslider');
      this.slider = wrapper ? wrapper.querySelector('cpage-image-slider') : null;

      this.swatches.forEach((sw) => sw.addEventListener('click', () => this.selectProduct(sw)));
      this.addEventListener('keydown', (e) => this.onKeydown(e));
      this.panels.forEach((panel) => this.initPanel(panel));

      if (this.addButton) {
        this.setupButtonColors();
        /* The product form's native submit (theme's product-form-component, also hooked by
           Kaching) performs the add — we don't fetch. But we still reflect adding → added on
           the button for UX. The click fires for both paths; we never call preventDefault or
           set the disabled attribute (that could block the submit), only visual state. */
        /* capture phase so our visual state fires even if Kaching stops bubble propagation */
        this.addButton.addEventListener('click', () => this.onAddClick(), true);
      }

      this.guide = this.querySelector('[data-size-guide]');
      if (this.guide) this.initGuide();

      this.initAccordions();
      this.initFitGuideDrawers();

      const initial = this.swatches.find((s) => s.getAttribute('aria-checked') === 'true') || this.swatches[0];
      this.selectProduct(initial, true);
      this.preselectFromUrl();
      this.initExternalVariantSync();
    }

    initPanel(panel) {
      const script = panel.querySelector('[data-variants]');
      try {
        panel.variants = script ? JSON.parse(script.textContent) : [];
      } catch {
        panel.variants = [];
      }

      panel.querySelectorAll('[data-option-value]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const pos = btn.dataset.position;
          panel.querySelectorAll('[data-option-value][data-position="' + pos + '"]').forEach((sibling) => {
            const active = sibling === btn;
            sibling.classList.toggle('is-selected', active);
            sibling.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          this.updateSelectedValueDisplay(panel, pos);
          this.updateVariant(panel, true);
        });
      });

      this.updateVariant(panel, false);
    }

    updateSelectedValueDisplay(panel, position) {
      const selected = panel.querySelector('[data-option-value][data-position="' + position + '"].is-selected');
      if (selected) {
        const display = panel.querySelector('[data-selected-value-' + position + ']');
        if (display) {
          display.textContent = selected.dataset.value;
        }
      }
    }

    getSelectedOptions(panel) {
      const options = [];
      panel.querySelectorAll('[data-option-position]').forEach((group) => {
        const pos = parseInt(group.dataset.optionPosition, 10);
        const selected = group.querySelector('[data-option-value].is-selected');
        if (selected) options[pos - 1] = selected.dataset.value;
      });
      return options;
    }

    /* data-price lives in the buttons block (outside panels); only update when this is the active panel */
    updateVariant(panel, fromUser) {
      const variants = panel.variants || [];
      if (variants.length) {
        const selected = this.getSelectedOptions(panel);
        let match = variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
        if (!match) match = variants[0];
        panel.currentVariant = match;
      }

      if (panel === this.activePanel) {
        const v = panel.currentVariant;
        const priceEl = this.querySelector('[data-price]');
        if (priceEl) {
          priceEl.textContent = v ? v.price + (v.available === false ? ' · Sold out' : '') : '';
        }
        /* Compare-at price: only shown when the variant is actually discounted */
        const compareEl = this.querySelector('[data-compare-price]');
        if (compareEl) {
          const compare = v && v.compare_at_price;
          compareEl.textContent = compare || '';
          compareEl.hidden = !compare;
        }
        this.updateAddToCart();
      }

      if (fromUser) this.syncSlider(panel);
    }

    selectProduct(swatch, silent) {
      const index = swatch.dataset.index;

      this.swatches.forEach((s) => {
        const active = s === swatch;
        s.classList.toggle('is-selected', active);
        s.setAttribute('aria-checked', active ? 'true' : 'false');
        s.tabIndex = active ? 0 : -1;
      });

      this.activePanel = null;
      this.panels.forEach((panel) => {
        const active = panel.dataset.index === index;
        panel.hidden = !active;
        if (active) this.activePanel = panel;
      });

      this.querySelectorAll('[data-selected-title]').forEach((el) => {
        el.textContent = swatch.dataset.title || '';
      });

      this.updateFitGuideImages(index);

      /* "Available Size" card — concise band for the selected style; hidden when unknown */
      const availEl = this.querySelector('[data-avail-size]');
      const bandEl = this.querySelector('[data-size-band-text]');
      const band = swatch.dataset.sizeBand || '';
      if (bandEl) bandEl.textContent = band;
      if (availEl) availEl.hidden = !band;

      /* updateVariant handles both price refresh and updateAddToCart for the active panel */
      if (this.activePanel) this.updateVariant(this.activePanel, false);
      else this.updateAddToCart();

      /* Always filter the slider to the selected product — including the initial
         (silent) selection on page load. Only the focus move is click-only. */
      this.syncSlider(this.activePanel);
      /* Move focus for keyboard/a11y, but never scroll the page to the swatch — the
         default focus() scroll-into-view was jumping the page on select. */
      if (!silent) {
        swatch.focus({ preventScroll: true });
        /* Blur after a short delay so the tooltip (shown on :focus-visible) disappears */
        requestAnimationFrame(() => swatch.blur());
      }
    }

    syncSlider(panel) {
      if (!this.slider || !panel) return;
      /* The slider element may not have upgraded/connected yet (e.g. image column
         positioned right renders after this selector). Retry once it's ready. */
      if (!this.slider.track) {
        if (!this._syncRetried) {
          this._syncRetried = true;
          requestAnimationFrame(() => this.syncSlider(panel));
        }
        return;
      }
      this._syncRetried = false;
      this.slider.filterByProductId(panel.dataset.productId);
      const variant = panel.currentVariant;
      if (variant && variant.image_id != null) this.slider.scrollToImageId(variant.image_id);
    }

    updateAddToCart() {
      if (!this.addButton) return;
      const variant = this.activePanel && this.activePanel.currentVariant;
      const soldOut = variant && variant.available === false;
      this.addButton.disabled = !variant || soldOut;

      /* Keep the product form's hidden variant id in sync with the selected style so the
         native form submit (and any cart/bundle app hooking it) adds the right variant.
         Disabled inputs aren't submitted, so we also gate it on availability. */
      if (this.variantIdInput && !this._applyingExternal) {
        /* While applying a selection that CAME FROM Kaching (_applyingExternal), the shared id
           is already what Kaching set — writing it back (incl. the transient default-variant id
           mid-apply) makes Kaching re-map all its bundle slots and clobber other picks. So we
           only sync the id for our own selections here.
           Flag this as our own write so the watcher doesn't mistake it for a customer change and
           loop. _lastVariantId tracks the value we last put there, compared in onExternalVariantId. */
        this._settingVariantId = true;
        if (variant && !soldOut) {
          this.variantIdInput.value = variant.id;
          this.variantIdInput.disabled = false;
          this._lastVariantId = String(variant.id);
        } else {
          this.variantIdInput.value = '';
          this.variantIdInput.disabled = true;
          this._lastVariantId = '';
        }
        this._settingVariantId = false;
      }

      if (soldOut) {
        this.addButton.textContent = this.addButton.dataset.soldOutLabel || 'Sold out';
        return;
      }
      let label = this.addButton.dataset.addLabel || 'Add to cart';
      /* optionally show the live variant price in the button, e.g. "Add to cart · $70.00" */
      if (this.addButton.dataset.showPrice === 'true' && variant && variant.price) {
        label += (this.addButton.dataset.priceSeparator || ' · ') + variant.price;
      }
      this.addButton.textContent = label;
    }

    /* ---- Add-to-cart visual state (the form/Kaching do the actual add) ---- */
    onAddClick() {
      const variant = this.activePanel && this.activePanel.currentVariant;
      /* sold out / no variant → button is disabled and won't submit; nothing to show */
      if (!variant || variant.available === false) return;
      this.startAdding();
    }

    /* AJAX add (portable cart mode): post to /cart/add.js, then notify cart-drawer apps/themes.
       UpCart also intercepts this fetch directly, which is what opens its drawer. */
    ajaxAdd() {
      const variant = this.activePanel && this.activePanel.currentVariant;
      if (!variant || variant.available === false) return;
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      this.startAdding();
      clearTimeout(this._addingTimer); // the real fetch drives completion, not the fallback timer
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }),
      })
        .then((r) => r.json())
        .then((data) => {
          if (data && data.status) throw new Error(data.description || 'add failed');
          this.markAdded();
          this.notifyCart();
        })
        .catch(() => {
          this._adding = false;
          if (this.addButton) this.addButton.classList.remove('is-loading');
          this.updateAddToCart();
        });
    }

    notifyCart() {
      /* Broadcast widely so whatever cart drawer is present refreshes/opens (theme- and
         app-agnostic). UpCart hooks the fetch above; these cover native theme drawers. */
      ['cart:refresh', 'cart:updated', 'cart:change', 'ajaxProduct:added', 'product:added'].forEach((name) =>
        document.dispatchEvent(new CustomEvent(name, { bubbles: true }))
      );
      try {
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'cpslider' });
        }
      } catch (e) {}
    }

    startAdding() {
      if (!this.addButton || this._adding) return;
      this._adding = true;
      /* capture the live text colour so the spinner is visible once we hide the label */
      this.addButton.style.setProperty('--cps-spin', getComputedStyle(this.addButton).color);
      this.addButton.classList.remove('is-added');
      this.addButton.classList.add('is-loading');
      clearTimeout(this._addedTimer);
      clearTimeout(this._addingTimer);
      /* We don't get a reliable completion signal across the theme form + Kaching + UpCart,
         so show the spinner briefly, then confirm with "Added". */
      this._addingTimer = setTimeout(() => this.markAdded(), 1000);
    }

    markAdded() {
      if (!this.addButton || !this._adding) return;
      this._adding = false;
      clearTimeout(this._addingTimer);
      this.addButton.classList.remove('is-loading');
      this.addButton.classList.add('is-added');
      this.addButton.textContent = this.addButton.dataset.addedLabel || 'Added';
      clearTimeout(this._addedTimer);
      this._addedTimer = setTimeout(() => {
        this.addButton.classList.remove('is-added');
        this.updateAddToCart();
      }, 1800);
    }

    addToCart() {
      const variant = this.activePanel && this.activePanel.currentVariant;
      if (!variant || variant.available === false) return;

      const root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
      this.addButton.classList.add('is-loading');
      this.addButton.disabled = true;

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }),
      })
        .then((r) => r.json())
        .then(() => {
          this.addButton.classList.remove('is-loading');
          document.dispatchEvent(new CustomEvent('cart:added', { bubbles: true, detail: { id: variant.id } }));
          this.flashAdded();
          this.openCartDrawer(root);
        })
        .catch(() => {
          this.addButton.classList.remove('is-loading');
          this.updateAddToCart();
        });
    }

    openCartDrawer(root) {
      const SECTION = 'cart-drawer-section';
      fetch((root || '/') + '?sections=' + SECTION)
        .then((r) => r.json())
        .then((data) => {
          const html = data[SECTION];
          if (html) {
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const fresh = parsed.getElementById('shopify-section-' + SECTION);
            const current = document.getElementById('shopify-section-' + SECTION);
            if (fresh && current) current.innerHTML = fresh.innerHTML;
          }
        })
        .catch(() => {})
        .finally(() => {
          const drawer = document.querySelector('theme-drawer#cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          } else if (window.Shopify?.actions?.openCart) {
            window.Shopify.actions.openCart();
          } else {
            window.location.href = root + 'cart';
          }
        });
    }

    flashAdded() {
      this.addButton.disabled = false;
      this.addButton.textContent = this.addButton.dataset.addedLabel || 'Added';
      clearTimeout(this.addedTimer);
      this.addedTimer = setTimeout(() => this.updateAddToCart(), 1800);
    }

    setupButtonColors() {
      const fg = getComputedStyle(this).color;
      const parts = fg.match(/\d+(\.\d+)?/g);
      if (!parts) return;
      const luminance = (0.299 * Number(parts[0]) + 0.587 * Number(parts[1]) + 0.114 * Number(parts[2])) / 255;
      this.style.setProperty('--cps-btn-bg', fg);
      this.style.setProperty('--cps-btn-fg', luminance < 0.55 ? '#ffffff' : '#111111');
    }

    onKeydown(e) {
      const keys = ['ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
      if (!keys.includes(e.key)) return;
      const current = this.swatches.findIndex((s) => s.getAttribute('aria-checked') === 'true');
      if (current === -1) return;
      e.preventDefault();
      const last = this.swatches.length - 1;
      let next = current;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = current === last ? 0 : current + 1;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = current === 0 ? last : current - 1;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = last;
      this.selectProduct(this.swatches[next]);
    }

    /* ---------- Size guide ---------- */
    initGuide() {
      this.guideOpeners = Array.from(this.querySelectorAll('[data-size-guide-open]'));
      this.guideOpeners.forEach((btn) => btn.addEventListener('click', () => this.openGuide(btn)));

      this.guide
        .querySelectorAll('[data-size-guide-close]')
        .forEach((el) => el.addEventListener('click', () => this.closeGuide(true)));
      const ok = this.guide.querySelector('[data-size-guide-ok]');
      if (ok) ok.addEventListener('click', () => this.closeGuide(true));

      this.guide.querySelectorAll('[data-bucket-toggle]').forEach((btn) =>
        btn.addEventListener('click', () => {
          const bucket = btn.closest('[data-bucket]');
          if (!bucket) return;
          const willOpen = !bucket.classList.contains('is-open');
          this.guide.querySelectorAll('[data-bucket]').forEach((b) => {
            b.classList.remove('is-open');
            const h = b.querySelector('[data-bucket-toggle]');
            if (h) h.setAttribute('aria-expanded', 'false');
          });
          if (willOpen) {
            bucket.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          }
        })
      );

      this.guide.querySelectorAll('[data-colors-more]').forEach((btn) =>
        btn.addEventListener('click', () => {
          const wrap = btn.closest('[data-colors]');
          if (wrap) wrap.classList.add('is-expanded');
        })
      );

      this.guideColors = Array.from(this.guide.querySelectorAll('[data-guide-color]'));
      this.guideColors.forEach((btn) => btn.addEventListener('click', () => this.setGuidePending(btn)));

      this.guide.querySelectorAll('[data-guide-card]').forEach((card) => {
        card.addEventListener('click', (e) => {
          if (e.target.closest('[data-guide-color]')) return;
          const firstColor = card.querySelector('[data-guide-color]');
          if (firstColor) this.setGuidePending(firstColor);
        });
      });

      this.onGuideKeydown = (e) => {
        if (e.key === 'Escape') this.closeGuide(true);
      };
    }

    openGuide(trigger) {
      if (!this.guide) return;
      this.guideTrigger = trigger || null;
      this.guidePending = null;

      this.guideColors.forEach((b) => b.classList.remove('is-selected'));
      this.guide.querySelectorAll('[data-guide-thumb]').forEach((img) => {
        if (img.dataset.defaultSrc) img.src = img.dataset.defaultSrc;
      });
      this.guide.querySelectorAll('[data-bucket]').forEach((b) => {
        b.classList.remove('is-open');
        const h = b.querySelector('[data-bucket-toggle]');
        if (h) h.setAttribute('aria-expanded', 'false');
      });
      this.updateNiceText(null);

      clearTimeout(this._guideHideTimer);
      this.guide.hidden = false;
      /* two frames so the panel paints off-screen before the drawer slides in */
      requestAnimationFrame(() => requestAnimationFrame(() => this.guide.classList.add('is-open')));
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onGuideKeydown);
      const dialog = this.guide.querySelector('.cpsg__dialog');
      if (dialog) dialog.focus();
    }

    closeGuide(commit) {
      if (!this.guide) return;
      if (commit && this.guidePending) {
        this.applyExternalSelection(this.guidePending.productId, this.guidePending.variantId);
      }
      this.guide.classList.remove('is-open');
      /* drawer variant slides out — wait for the transition before hiding; modal hides at once */
      const isDrawer = this.guide.classList.contains('cpsg--drawer');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (isDrawer && !reduced) {
        clearTimeout(this._guideHideTimer);
        this._guideHideTimer = setTimeout(() => { this.guide.hidden = true; }, 320);
      } else {
        this.guide.hidden = true;
      }
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', this.onGuideKeydown);
      if (this.guideTrigger && typeof this.guideTrigger.focus === 'function') this.guideTrigger.focus();
    }

    setGuidePending(button) {
      this.guideColors.forEach((b) => b.classList.toggle('is-selected', b === button));
      this.guidePending = { productId: button.dataset.productId, variantId: button.dataset.variantId };
      this.updateNiceText(button);
      this.updateGuideCardImage(button);
    }

    /* Show the selected colour's variant image; fall back to the card's main image */
    updateGuideCardImage(button) {
      const card = button.closest('[data-guide-card]');
      if (!card) return;
      const img = card.querySelector('[data-guide-thumb]');
      if (!img) return;
      const variantImage = button.dataset.variantImage;
      img.src = variantImage || img.dataset.defaultSrc || img.src;
    }

    updateNiceText(button) {
      const niceText = this.guide && this.guide.querySelector('[data-guide-nice-text]');
      const nameEl = this.guide && this.guide.querySelector('[data-guide-selected-name]');
      if (!niceText || !nameEl) return;
      const title = button && button.dataset.productTitle;
      if (title) {
        nameEl.textContent = title;
        niceText.hidden = false;
      } else {
        niceText.hidden = true;
      }
    }

    initAccordions() {
      this.querySelectorAll('[data-accordion-head]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const item = btn.closest('[data-accordion]');
          if (!item) return;
          const isOpen = item.classList.contains('is-open');
          item.classList.toggle('is-open', !isOpen);
          btn.setAttribute('aria-expanded', String(!isOpen));
        });
      });
    }

    /* Swap the fitting-guide drawer images to the selected product's metafield images.
       Falls back to the block's default image when a product has none. */
    updateFitGuideImages(index) {
      const boxes = this.querySelectorAll('[data-fitguide-images]');
      if (!boxes.length) return;
      boxes.forEach((box) => {
        const container = box.closest('[data-fitguide]');
        if (!container) return;
        if (container._fitMap === undefined) {
          const script = container.querySelector('[data-fitguide-map]');
          try {
            container._fitMap = script ? JSON.parse(script.textContent) : {};
          } catch {
            container._fitMap = {};
          }
        }
        const map = container._fitMap || {};
        let urls = map[index] || [];
        if (!urls.length && box.dataset.defaultImage) urls = [box.dataset.defaultImage];
        box.innerHTML = urls
          .map((u) => {
            const s = this.fitImageSrc(u);
            // Wrapper clips the scaled image so zoom stays inside the drawer (no lightbox).
            return `<div class="cpfg-drawer__zoom" data-fitguide-zoom><img class="cpfg-drawer__image" src="${s.src}" srcset="${s.srcset}" sizes="(max-width: 500px) 92vw, 820px" alt="" loading="lazy" decoding="async"></div>`;
          })
          .join('');
        this.wireFitZoom(box);
      });
    }

    // Build a responsive srcset from a Shopify CDN image URL by varying the `width` param, and
    // request a generously-sized default so the fitting guide reads sharp (incl. when zoomed).
    fitImageSrc(url) {
      if (!url) return { src: '', srcset: '' };
      let base = url;
      try {
        const u = new URL(url, document.baseURI);
        u.searchParams.delete('width');
        u.searchParams.delete('height');
        base = u.href;
      } catch (e) {
        base = url.replace(/[?&](width|height)=\d+/g, '').replace(/[?&]$/, '');
      }
      const sep = base.includes('?') ? '&' : '?';
      const widths = [480, 768, 1080, 1440, 1920];
      const srcset = widths.map((w) => `${base}${sep}width=${w} ${w}w`).join(', ');
      return { src: `${base}${sep}width=1080`, srcset };
    }

    // In-drawer image zoom: hover shows a zoom-in cursor; click zooms (scaled, clipped inside the
    // drawer — not a lightbox); moving the pointer while zoomed pans; a held drag doesn't exit zoom.
    wireFitZoom(scope) {
      const ZOOM = 2.4;
      const DRAG = 6; // px moved since pointerdown that counts as a drag/pan, not a click
      scope.querySelectorAll('[data-fitguide-zoom]').forEach((box) => {
        const img = box.querySelector('img');
        if (!img) return;
        img.style.setProperty('--cpfg-zoom', ZOOM);
        let zoomed = false;
        let startX = 0;
        let startY = 0;
        let moved = false;
        const panTo = (clientX, clientY) => {
          const r = box.getBoundingClientRect();
          const px = Math.min(1, Math.max(0, (clientX - r.left) / r.width));
          const py = Math.min(1, Math.max(0, (clientY - r.top) / r.height));
          img.style.transformOrigin = `${px * 100}% ${py * 100}%`;
        };
        box.addEventListener('pointerdown', (e) => {
          startX = e.clientX;
          startY = e.clientY;
          moved = false;
        });
        box.addEventListener('pointermove', (e) => {
          if (!moved && Math.hypot(e.clientX - startX, e.clientY - startY) > DRAG) moved = true;
          if (zoomed) panTo(e.clientX, e.clientY);
        });
        box.addEventListener('click', (e) => {
          // A drag (holding + moving to pan) fires a click on release — ignore it so zoom stays.
          if (moved) {
            moved = false;
            return;
          }
          zoomed = !zoomed;
          if (zoomed) panTo(e.clientX, e.clientY);
          box.classList.toggle('is-zoomed', zoomed);
        });
        box.addEventListener('pointerleave', () => {
          if (!zoomed) return;
          zoomed = false;
          box.classList.remove('is-zoomed');
        });
      });
    }

    /* ---------- Fitting-guide drawer (right on desktop, bottom sheet on mobile) ---------- */
    initFitGuideDrawers() {
      const triggers = Array.from(this.querySelectorAll('[data-fitguide-open]'));
      if (!triggers.length) return;

      this.openFitDrawerEl = null;
      this.fitTrigger = null;
      this.onFitKeydown = (e) => {
        if (e.key === 'Escape' && this.openFitDrawerEl) this.closeFitDrawer(this.openFitDrawerEl);
      };

      triggers.forEach((btn) => {
        /* The trigger card lives in the swatches block, so resolve its drawer by the
           target id it points at; fall back to an ancestor [data-fitguide] container. */
        let container = null;
        if (btn.dataset.fitguideTarget) container = document.getElementById(btn.dataset.fitguideTarget);
        if (!container) container = btn.closest('[data-fitguide]');
        const drawer = container && container.querySelector('[data-fitguide-drawer]');
        if (!drawer) return;
        btn.addEventListener('click', () => this.openFitDrawer(btn, drawer));
        drawer
          .querySelectorAll('[data-fitguide-close]')
          .forEach((el) => el.addEventListener('click', () => this.closeFitDrawer(drawer)));
      });
    }

    openFitDrawer(trigger, drawer) {
      this.fitTrigger = trigger;
      this.openFitDrawerEl = drawer;
      drawer.hidden = false;
      /* Two frames so the panel paints in its off-screen state before transitioning in */
      requestAnimationFrame(() => requestAnimationFrame(() => drawer.classList.add('is-open')));
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onFitKeydown);
      trigger.setAttribute('aria-expanded', 'true');
      const panel = drawer.querySelector('.cpfg-drawer__panel');
      if (panel) panel.focus();
    }

    closeFitDrawer(drawer) {
      drawer.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', this.onFitKeydown);

      const panel = drawer.querySelector('.cpfg-drawer__panel');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (panel && !reduced) {
        let done = false;
        const finish = () => {
          if (done) return;
          done = true;
          panel.removeEventListener('transitionend', finish);
          drawer.hidden = true;
        };
        panel.addEventListener('transitionend', finish);
        setTimeout(finish, 400);
      } else {
        drawer.hidden = true;
      }

      if (this.fitTrigger) {
        this.fitTrigger.setAttribute('aria-expanded', 'false');
        this.fitTrigger.focus();
      }
      this.openFitDrawerEl = null;
    }

    preselectFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const vid = params.get('variant') || params.get('fyf_variant');
      if (!vid) return;
      for (const panel of this.panels) {
        if ((panel.variants || []).some((v) => String(v.id) === String(vid))) {
          this.applyExternalSelection(panel.dataset.productId, vid);
          return;
        }
      }
    }

    applyExternalSelection(productId, variantId) {
      const swatch = this.swatches.find((s) => s.dataset.productId === String(productId));
      if (swatch) this.selectProduct(swatch, true);

      const panel = this.activePanel;
      if (!panel) return;

      const target = (panel.variants || []).find((v) => String(v.id) === String(variantId));
      if (target && Array.isArray(target.options)) {
        panel.querySelectorAll('[data-option-position]').forEach((group) => {
          const pos = parseInt(group.dataset.optionPosition, 10);
          const want = target.options[pos - 1];
          group.querySelectorAll('[data-option-value]').forEach((btn) => {
            const active = btn.dataset.value === want;
            btn.classList.toggle('is-selected', active);
            btn.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          this.updateSelectedValueDisplay(panel, pos);
        });
      }

      this.updateVariant(panel, true);
    }

    /* ---- External selection sync (Kaching bundles / any app-driven variant change) ----
       Our swatch normally drives the shared form's hidden variant id (updateAddToCart). When
       Kaching lets the customer switch variant/style in its own widget, it changes that same
       id. We watch it for changes we didn't make and move the swatch (+ reflect the exact
       variant's options) to match, reusing applyExternalSelection.

       Kaching's write mechanism isn't known, so we cover them all: bubbling change/input
       events, common variant pub-sub events, attribute mutations, and a cheap safety-net poll
       for property-only writes (input.value = … fires no event and doesn't touch the
       attribute). Every path funnels through onExternalVariantId, which no-ops unless the id
       genuinely changed to one of our variants. */
    initExternalVariantSync() {
      if (!this.variantIdInput) return;
      if (this._lastVariantId == null) this._lastVariantId = String(this.variantIdInput.value || '');

      this._extVariantCheck = () => this.onExternalVariantId(this.variantIdInput.value);

      ['change', 'input'].forEach((evt) => this.variantIdInput.addEventListener(evt, this._extVariantCheck));
      this._extVariantEvents = ['variant:change', 'variantChange', 'product:variant-change', 'on:variant:change'];
      this._extVariantEvents.forEach((evt) => document.addEventListener(evt, this._extVariantCheck));

      try {
        this._variantObserver = new MutationObserver(this._extVariantCheck);
        this._variantObserver.observe(this.variantIdInput, { attributes: true, attributeFilter: ['value'] });
      } catch (e) {}

      this._variantPoll = setInterval(this._extVariantCheck, 700);
    }

    onExternalVariantId(rawId) {
      if (this._settingVariantId) return; // our own write — ignore
      const id = String(rawId || '');
      if (!id || id === String(this._lastVariantId || '')) return;

      /* Only react to ids we actually own (a variant of one of the styles). */
      let owner = null;
      for (const panel of this.panels) {
        if ((panel.variants || []).some((v) => String(v.id) === id)) {
          owner = panel;
          break;
        }
      }
      if (!owner) return;

      this._lastVariantId = id; // set before applying so the poll sees equality and won't re-fire
      /* Reflect Kaching's choice on our UI WITHOUT writing the shared id back (the id is already
         Kaching's) — otherwise our write, incl. the transient default-variant id during the apply,
         makes Kaching re-map its other bundle slots and overwrite earlier picks. */
      this._applyingExternal = true;
      try {
        this.applyExternalSelection(owner.dataset.productId, id);
      } finally {
        this._applyingExternal = false;
      }
    }

    disconnectedCallback() {
      if (this._variantPoll) clearInterval(this._variantPoll);
      if (this._variantObserver) this._variantObserver.disconnect();
      if (this._extVariantCheck) {
        if (this.variantIdInput) {
          ['change', 'input'].forEach((evt) => this.variantIdInput.removeEventListener(evt, this._extVariantCheck));
        }
        (this._extVariantEvents || []).forEach((evt) => document.removeEventListener(evt, this._extVariantCheck));
      }
    }
  }

  if (!customElements.get('cpage-product-selector')) {
    customElements.define('cpage-product-selector', CpageProductSelector);
  }

  } catch(e) { console.error(e); }
})();
})();
